<template>
  <div style="overflow: hidden">
    <div
      v-if="loading"
      class="wg-row"
      style="margin: 10px; justify-content: center; margin-top: 10px"
    >
      <vue-simple-spinner
        size="medium"
        :line-fg-color="appColor"
      ></vue-simple-spinner>
    </div>
    <template v-if="!loading">
      <!-- LOADING MODAL -->
      <wg-modal :simple="true" :width="'200px'" v-if="updating">
        <template slot="body">
          <div
            class="wg-row com-anm22-app-text-l"
            style="justify-content: center"
          >
            {{ $anm22.strLang(lang, "Loading...", "Elaborazione in corso...") }}
          </div>
          <div class="vertical-height-div" style="height: 20px"></div>
          <div
            class="wg-row"
            style="align-items: center; justify-content: center"
          >
            <vue-simple-spinner
              size="medium"
              :line-fg-color="appColor"
            ></vue-simple-spinner>
          </div>
        </template>
      </wg-modal>
      <!-- COVER MODAL -->
      <cover-modal
        v-if="license.config.modules.tables.enabled && showCoverModal"
        :order="order"
        :contact="contact"
        @cover-modal-update="updateCoversModalData"
        @select-contact="selectContact"
        @reset-contact="resetContact"
      ></cover-modal>
      <!-- VARIATIONS MODAL -->
      <var-modal
        v-if="varModalElement"
        :show="showVarModal"
        :element="varModalElement"
        @set-variations="setVariations"
      ></var-modal>
      <wg-modal
        :width="'400px'"
        v-if="showClearListModal"
        @closeModal="showClearListModal = false"
      >
        <div
          slot="body"
          class="wg-row no-select"
          style="justify-content: center"
        >
          <div class="com-anm22-app-text-xl" style="margin-bottom: 20px">
            {{
              $anm22.strLang(
                lang,
                "Do you want to empty the list?",
                "Vuoi svuotare la lista articoli?"
              )
            }}
          </div>
          <div
            class="wg-row"
            style="
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
            "
          >
            <div class="display-flex action-btn-with-desc">
              <img
                :src="$anm22.icons.getWorldIcon('tick')"
                class="btn"
                :title="$anm22.strLang(lang, 'Yes', 'Sì')"
                @click="
                  emptyCart();
                  showClearListModal = false;
                "
              />
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Yes", "Sì") }}
              </div>
            </div>
            <div class="display-flex action-btn-with-desc">
              <img
                :src="$anm22.icons.getWorldIcon('deleteBlack')"
                class="btn"
                style="padding: 20px"
                :title="$anm22.strLang(lang, 'No', 'No')"
                @click="showClearListModal = false"
              />
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "No", "No") }}
              </div>
            </div>
          </div>
        </div>
      </wg-modal>
      <!-- NOTES MODAL -->
      <wg-modal
        v-if="showNotesModal"
        :width="'80%'"
        @closeModal="showNotesModal = false"
      >
        <div slot="header" class="com-anm22-app-text-xxl no-select">
          {{ $anm22.strLang(lang, "Notes", "Note") }}
        </div>
        <div class="wg-row" slot="body" style="justify-content: flex-end">
          <textarea
            slot="body"
            style="
              max-width: 100%;
              width: 100%;
              height: 100px;
              border: 1px solid #ddd;
            "
            ref="fc-notes"
            @focus="pauseKeyboardListener = true"
            @blur="pauseKeyboardListener = false"
            :value="order.notes"
          ></textarea>
          <div class="vertical-height-div" style="height: 10px"></div>
          <button class="small" @click="saveNotes">
            <div class="com-anm22-app-text-l">
              {{ $anm22.strLang(lang, "Confirm", "Conferma") }}
            </div>
          </button>
        </div>
      </wg-modal>
      <!-- PAYMENT MODAL -->
      <wg-modal
        :width="windowWidth > 900 ? '900px' : '90%'"
        v-if="showPaymentModal"
        @closeModal="closePaymentModal"
      >
        <div slot="header" class="com-anm22-app-text-xl">
          {{
            $anm22.strLang(
              lang,
              "Choose a payment method",
              "Scegli un metodo di pagamento"
            )
          }}
        </div>
        <div
          slot="body"
          class="wg-row"
          :style="{ height: Math.floor((windowHeight / 100) * 90) - 90 + 'px' }"
        >
          <div
            class="wg-row no-select"
            style="
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
            "
          >
            <div
              class="wg-row"
              style="
                flex-wrap: nowrap;
                align-items: center;
                justify-content: space-around;
                border-top: 1px solid #ccc;
                border-right: 1px solid #ccc;
              "
            >
              <div
                v-for="(pm, index) in paymentMethods.map((pm) =>
                  $anm22.tableClasses.worldPaymentModeType().getById(pm)
                )"
                :key="'pm+' + index"
                :class="[
                  'wg-row',
                  'fc-cp-select',
                  paymentTempSelect == pm.typeClass ? 'selected' : '',
                  pm.typeClass === 7 && isOffline ? 'disabled' : '',
                ]"
                @click="setPaymentMethod(pm)"
              >
                <img
                  :src="
                    $anm22.icons.getWorldIcon(
                      'payment' + $anm22.capitalizeFirst(pm.typeClassLiteral)
                    )
                  "
                  class="com-anm22-app-img-l"
                  :style="getPmStyle(pm)"
                  :title="pm[lang]"
                />
              </div>
            </div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="wg-row" style="height: calc(100% - 90px)">
            <!-- Componente mappa YB per selezione ombrellone -->
            <yb-map
              v-if="paymentTempSelect === 7"
              :mode="'payment'"
              :selectRef="ybSelectRef"
              @yb-payment="setYbPayment"
            ></yb-map>
            <!-- Ricerca tessere Pay -->
            <template v-else-if="paymentTempSelect === 9">
              <div class="wg-row com-anm22-app-text-l pay-hint-search">
                <div class="display-flex pay-hint-search-inputs">
                  <input
                    type="text"
                    v-model="payInputName"
                    @focus="pauseKeyboardListener = true"
                    @blur="pauseKeyboardListener = false"
                    :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
                  />
                  <input
                    type="text"
                    v-model="payInputEmail"
                    @focus="pauseKeyboardListener = true"
                    @blur="pauseKeyboardListener = false"
                    placeholder="Email"
                  />
                  <input
                    type="text"
                    v-model="payInputNumber"
                    :placeholder="$anm22.strLang(lang, 'Number', 'Numero')"
                    @focus="pauseKeyboardListener = true"
                    @blur="pauseKeyboardListener = false"
                  />
                </div>
                <button class="small" @click="searchPayCards">
                  <img :src="$anm22.icons.getWorldIcon('searchLeft')" />
                  <div class="wg-xs-none wg-sm-">
                    {{ $anm22.strLang(lang, "Search", "Cerca") }}
                  </div>
                </button>
              </div>
              <div class="wg-row com-anm22-app-scrolling-panel pay-hint-div">
                <div
                  v-if="loadingPayHints"
                  class="wg-row"
                  style="
                    margin: 10px;
                    justify-content: center;
                    margin-top: 10px;
                  "
                >
                  <vue-simple-spinner size="medium" :line-fg-color="appColor" />
                </div>
                <div
                  v-else-if="payHints.length === 0"
                  class="wg-row"
                  style="
                    margin: 20px 0;
                    justify-content: center;
                    text-align: center;
                  "
                >
                  <div class="com-anm22-app-text-xl">
                    {{
                      $anm22.strLang(
                        lang,
                        "No cards found",
                        "Nessuna tessera trovata"
                      )
                    }}
                  </div>
                </div>
                <anm-22-pay-card
                  v-else
                  v-for="(h, i) in payHints"
                  :key="'pay-hint-' + i"
                  @click.native="setPayPayment(h)"
                  :card="h"
                  :timezone="timezone"
                  :view="'employee'"
                ></anm-22-pay-card>
              </div>
            </template>
          </div>
        </div>
      </wg-modal>
      <!-- DELIVERY MODAL -->
      <wg-modal
        :width="windowWidth > 900 ? '900px' : '90%'"
        v-if="showDeliveryModal"
        @closeModal="closeDeliveryModal"
      >
        <div slot="header" class="com-anm22-app-text-xl">
          {{
            $anm22.strLang(
              lang,
              "Choose a delivery method",
              "Scegli un metodo di consegna"
            )
          }}
        </div>
        <div
          slot="body"
          class="wg-row"
          :style="{ height: Math.floor((windowHeight / 100) * 90) - 90 + 'px' }"
        >
          <div
            class="wg-row no-select"
            style="
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
            "
          >
            <div
              class="wg-row"
              style="
                flex-wrap: nowrap;
                align-items: center;
                justify-content: space-around;
                border-top: 1px solid #ccc;
                border-right: 1px solid #ccc;
              "
            >
              <div
                v-for="(dt, index) in deliveryTypes.map((dt) =>
                  $anm22.tableClasses.worldDeliveryType().getById(dt)
                )"
                :key="'dt+' + index"
                :class="[
                  'wg-row',
                  'fc-cp-select',
                  deliveryTempSelect == dt.typeClass ? 'selected' : '',
                ]"
                @click="setDeliveryType(dt)"
              >
                <img
                  :src="$anm22.icons.getWorldIcon(dt.typeClassLiteral)"
                  :style="getDeliveryIconStyle(dt)"
                  :title="dt[lang]"
                />
              </div>
            </div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <template v-if="deliveryTempSelect !== 5">
            <div class="wg-row" style="justify-content: center">
              <div
                class="display-flex"
                style="
                  width: 300px;
                  flex-wrap: nowrap;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <div class="com-anm22-app-text-l">
                  {{ $anm22.strLang(lang, "Time", "Orario") }}
                </div>
                <select
                  class="com-anm22-app-select"
                  style="width: 150px; margin-left: 10px"
                  v-model="order.deliveryTime"
                >
                  <option value="" selected disabled>
                    {{ $anm22.strLang(lang, "Select one", "Seleziona") }}
                  </option>
                  <option
                    v-for="(ds, i) in deliverySlots"
                    :disabled="!ds.free"
                    :key="'ds-' + i"
                    :value="ds.slot.unix()"
                  >
                    {{ ds.slot.format("l LT") }}
                  </option>
                </select>
              </div>
            </div>
            <div class="vertical-height-div" style="height: 10px"></div>
          </template>
          <div
            class="wg-row"
            :style="{
              height:
                deliveryTempSelect === 5
                  ? 'calc(100% - 70px)'
                  : 'calc(100% - 116px)',
            }"
          >
            <yb-map
              v-if="deliveryTempSelect === 1 || deliveryTempSelect === 2"
              slot="body"
              :mode="'delivery'"
              :selectRef="ybSelectRef"
              @yb-delivery="setYbDelivery"
            ></yb-map>
            <tables-manage
              v-if="deliveryTempSelect === 5"
              :tableRef="order.tableRef"
              :freeFn="setTable"
              :occupiedFn="() => $anm22.eventBus.$emit('wg-modal-close')"
            ></tables-manage>
            <div
              v-if="deliveryTempSelect == 7"
              class="wg-row"
              style="margin-top: 10px; justify-content: center"
            >
              <div class="com-anm22-app-text-xl">
                {{
                  $anm22.strLang(
                    lang,
                    "Delivery address",
                    "Indirizzo di consegna"
                  )
                }}
              </div>
              <div class="vertical-height-div" style="height: 10px"></div>
              <input
                style="width: 300px"
                type="text"
                :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
                @focus="pauseKeyboardListener = true"
                @blur="pauseKeyboardListener = false"
                v-model="order.deliveryData.name"
              />
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="display-flex" style="flex-wrap: nowrap">
                <input
                  style="width: 255px"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Street', 'Via')"
                  @focus="pauseKeyboardListener = true"
                  @blur="pauseKeyboardListener = false"
                  v-model="order.deliveryData.street"
                />
                <input
                  style="width: 40px; margin-left: 5px"
                  type="text"
                  placeholder="N."
                  @focus="pauseKeyboardListener = true"
                  @blur="pauseKeyboardListener = false"
                  v-model="order.deliveryData.number"
                />
              </div>
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="display-flex" style="flex-wrap: nowrap">
                <input
                  style="width: 300px"
                  type="text"
                  :placeholder="
                    $anm22.strLang(
                      lang,
                      'Building/unit',
                      'Edificio/appartamento'
                    )
                  "
                  @focus="pauseKeyboardListener = true"
                  @blur="pauseKeyboardListener = false"
                  v-model="order.deliveryData.line2"
                />
              </div>
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="display-flex" style="flex-wrap: nowrap">
                <input
                  style="width: 215px"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'City', 'Città')"
                  @focus="pauseKeyboardListener = true"
                  @blur="pauseKeyboardListener = false"
                  v-model="order.deliveryData.city"
                />
                <input
                  style="width: 80px; margin-left: 5px"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'ZIP', 'CAP')"
                  @focus="pauseKeyboardListener = true"
                  @blur="pauseKeyboardListener = false"
                  v-model="order.deliveryData.zip"
                />
              </div>
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="display-flex" style="flex-wrap: nowrap">
                <input
                  style="width: 145px"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'State', 'Provincia')"
                  @focus="pauseKeyboardListener = true"
                  @blur="pauseKeyboardListener = false"
                  v-model="order.deliveryData.state"
                />
                <select
                  class="com-anm22-app-select"
                  style="width: 150px; margin-left: 5px"
                  v-model="order.deliveryData.country"
                >
                  <option value="it" selected>
                    {{ $anm22.strLang(lang, "Italy", "Italia") }}
                  </option>
                  <option value="rsm">
                    {{
                      $anm22.strLang(
                        lang,
                        "Republic of San Marino",
                        "Republica di San Marino"
                      )
                    }}
                  </option>
                </select>
              </div>
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="display-flex" style="flex-wrap: nowrap">
                <input
                  style="width: 300px"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Phone', 'Telefono')"
                  v-model="order.deliveryData.phone"
                />
              </div>
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="display-flex" style="flex-wrap: nowrap">
                <input
                  style="width: 300px"
                  type="text"
                  @focus="pauseKeyboardListener = true"
                  @blur="pauseKeyboardListener = false"
                  :placeholder="$anm22.strLang(lang, 'Notes', 'Note')"
                  v-model="order.deliveryData.notes"
                />
              </div>
            </div>
            <!-- Pickup point -->
            <div
              v-if="deliveryTempSelect == 9"
              class="wg-row"
              style="margin-top: 10px; justify-content: center"
            >
              <div class="com-anm22-app-text-xl">
                {{ $anm22.strLang(lang, "Pick-up point", "Punto di ritiro") }}
              </div>
              <div class="vertical-height-div" style="height: 10px"></div>
              <div style="width: 300px">
                <div
                  v-for="(point, i) in license.deliveryPickUpPoints"
                  :key="'pup-' + i"
                  class="pup-card"
                  @click="setPickUpPointDelivery(point)"
                >
                  <div
                    :class="[
                      point['it'] === order.pickUpPoint['it'] ? 'selected' : '',
                    ]"
                  >
                    {{ point[lang] }}
                  </div>
                </div>
              </div>
            </div>
            <!-- Bungalow -->
            <div
              v-if="deliveryTempSelect == 10"
              class="wg-row"
              style="margin-top: 10px; justify-content: center"
            >
              <div class="com-anm22-app-text-xl">
                {{
                  $anm22.strLang(
                    lang,
                    "Bungalow address",
                    "Indirizzo del bungalow"
                  )
                }}
              </div>
              <div class="vertical-height-div" style="height: 10px"></div>
              <input
                style="width: 300px"
                type="text"
                :placeholder="$anm22.strLang(lang, 'Name', 'Nome')" 
                @focus="pauseKeyboardListener = true"
                @blur="pauseKeyboardListener = false"
                v-model="order.deliveryData.name"
              />
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="display-flex" style="flex-wrap: nowrap">
                <input
                  style="width: 255px"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Street', 'Via')"
                  @focus="pauseKeyboardListener = true"
                  @blur="pauseKeyboardListener = false"
                  v-model="order.deliveryData.street"
                />
                <input
                  style="width: 40px; margin-left: 5px"
                  type="text"
                  placeholder="N."
                  @focus="pauseKeyboardListener = true"
                  @blur="pauseKeyboardListener = false"
                  v-model="order.deliveryData.number"
                />
              </div>
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="display-flex" style="flex-wrap: nowrap">
                <input
                  style="width: 300px"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Phone', 'Telefono')"
                  @focus="pauseKeyboardListener = true"
                  @blur="pauseKeyboardListener = false"
                  v-model="order.deliveryData.phone"
                />
              </div>
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="display-flex" style="flex-wrap: nowrap">
                <input
                  style="width: 300px"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Notes', 'Note')"
                  @focus="pauseKeyboardListener = true"
                  @blur="pauseKeyboardListener = false"
                  v-model="order.deliveryData.notes"
                />
              </div>
            </div>
          </div>
        </div>
      </wg-modal>
      <!-- PAGAMENTO IMMEDIATO YB -->
      <wg-modal
        :width="'900px'"
        v-if="showYbInstantModal"
        @closeModal="showYbInstantModal = false"
      >
        <div
          class="wg-row no-select"
          slot="body"
          style="justify-content: center; text-align: center"
        >
          <div class="com-anm22-app-text-xl" style="margin-bottom: 20px">
            {{
              $anm22.strLang(
                lang,
                "Do you want to pay immediately the bill with Spiagge.it?",
                "Vuoi pagare immediatamente il conto con Spiagge.it?"
              )
            }}
          </div>
          <div
            class="wg-row"
            style="flex-wrap: nowrap; justify-content: space-around"
          >
            <div
              v-for="(printer, index) in printers.filter(
                (p) => p.printMode.fis
              )"
              :key="'printer-fis-ticket-' + index"
              class="display-flex action-btn-with-desc"
            >
              <img
                :src="$anm22.icons.getWorldIcon('printf')"
                class="btn print-button-fis"
                :title="printer.name"
                @click="print(printer.idPrinter, 'fis')"
              />
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Fiscal", "Fiscale") }}
              </div>
              <div class="com-anm22-app-text-m">{{ printer.name }}</div>
            </div>
            <div
              v-for="(printer, index) in printers.filter(
                (p) => p.printMode.text
              )"
              :key="'printer-text-recap-' + index"
              class="display-flex action-btn-with-desc"
            >
              <img
                :src="$anm22.icons.getWorldIcon('print')"
                class="btn print-button-nfis"
                :title="printer.name"
                @click="printRecap(printer.idPrinter)"
              />
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Recap", "Riepilogo") }}
              </div>
              <div class="com-anm22-app-text-m">{{ printer.name }}</div>
            </div>
            <div class="display-flex action-btn-with-desc">
              <img
                :src="$anm22.icons.getWorldIcon('cash')"
                class="btn"
                @click="payOrderWithYB"
              />
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Pay", "Paga") }}
              </div>
            </div>
            <div class="display-flex action-btn-with-desc">
              <img
                :src="$anm22.icons.getWorldIcon('deleteBlack')"
                class="btn"
                @click="showYbInstantModal = false"
              />
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Close", "Chiudi") }}
              </div>
            </div>
          </div>
        </div>
      </wg-modal>
      <!-- Modale firma digitale YB -->
      <wg-modal
        v-if="showYbSignModal"
        @closeModal="showYbSignModal = false"
      >
        <anm-22-board 
            slot="body" 
            :width="windowWidth > 600 ? 600 : (windowWidth * 0.8)"
            :height="windowHeight > 400 ? 400 : (windowHeight * 0.8)"
            :saveFn="saveYbSignature"
        ></anm-22-board>
      </wg-modal>
      <!-- PRT MODAL -->
      <wg-modal v-if="showPrtModal" @closeModal="showPrtModal = false">
        <div
          slot="body"
          class="wg-row"
          style="flex-direction: column; align-items: center"
        >
          <div class="com-anm22-app-text-xxl">
            {{ $anm22.strLang(lang, "Print", "Stampa") }}
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div
            class="wg-row"
            style="flex-wrap: nowrap; justify-content: space-around"
          >
            <!-- <div
              v-for="(printer, index) in printers.filter(
                (p) => p.printMode.fis
              )"
              :key="'printer-fis-ticket-' + index"
              class="display-flex action-btn-with-desc"
            >
              <img
                :src="$anm22.icons.getWorldIcon('printf')"
                class="btn print-button-fis"
                :title="printer.name"
                @click="printNotPaid(printer.idPrinter)"
              >
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Not paid', 'Non riscosso') }}</div>
              <div class="com-anm22-app-text-m">{{ printer.name }}</div>
            </div> -->
            <div
              v-for="(printer, index) in printers.filter(
                (p) => p.printMode.text
              )"
              :key="'printer-text-recap-' + index"
              class="display-flex action-btn-with-desc"
            >
              <img
                :src="$anm22.icons.getWorldIcon('print')"
                class="btn print-button-nfis"
                :title="printer.name"
                @click="printRecap(printer.idPrinter)"
              />
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Recap", "Riepilogo") }}
              </div>
              <div class="com-anm22-app-text-m">{{ printer.name }}</div>
            </div>
            <div
              v-for="(printer, index) in printers.filter(
                (p) => p.printMode.nfis
              )"
              :key="'printer-nfis-' + index"
              class="display-flex action-btn-with-desc"
            >
              <img
                :src="$anm22.icons.getWorldIcon('print')"
                class="btn print-button-nfis"
                :title="printer.name"
                @click="
                  print(printer.idPrinter, 'nfis');
                  showPrtModal = false;
                "
              />
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Bill preview", "Pre conto") }}
              </div>
              <div class="com-anm22-app-text-m">{{ printer.name }}</div>
            </div>
            <!-- Fiscal printer management -->
            <div
              v-if="hasFiscalPrinters"
              class="display-flex action-btn-with-desc"
            >
              <img
                :src="$anm22.icons.getWorldIcon('menuSettings')"
                class="btn"
                :title="
                  $anm22.strLang(lang, 'Manage printers', 'Gestione stampanti')
                "
                @click="
                  showPrtModal = false;
                  showManagePrintersModal = true;
                "
              />
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(lang, "Manage printers", "Gestione stampanti")
                }}
              </div>
            </div>
          </div>
          <div class="vertical-height-div" style="height: 20px"></div>
          <div class="com-anm22-app-text-xxl">
            {{ $anm22.strLang(lang, "Other", "Altro") }}
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div
            class="wg-row"
            style="flex-wrap: nowrap; justify-content: space-around"
          >
            <div
              v-if="license.config.modules.sequences.enabled"
              class="display-flex action-btn-with-desc"
            >
              <img
                :src="$anm22.icons.getWorldIcon('printInvoice')"
                class="btn"
                :title="
                  $anm22.strLang(
                    lang,
                    'Reprint Kitchen Ticket',
                    'Ristampa comanda'
                  )
                "
                @click="printKitchenTicket()"
              />
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(
                    lang,
                    "Reprint Kitchen Ticket",
                    "Ristampa comanda"
                  )
                }}
              </div>
            </div>
            <!-- If document series is selected -->
            <div
              v-if="license.config.modules.invoices.enabled"
              class="display-flex action-btn-with-desc"
            >
              <img
                :src="$anm22.icons.getWorldIcon('printInvoice')"
                class="btn"
                :title="$anm22.strLang(lang, 'Invoice', 'Fattura')"
                :style="
                  canEmitInvoice ? {} : { opacity: 0.3, cursor: 'default' }
                "
                @click="printInvoice()"
              />
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Invoice", "Fattura") }}
              </div>
            </div>
            <div v-if="accessControl.payOrder" class="display-flex action-btn-with-desc">
              <img
                :src="$anm22.icons.getWorldIcon('cash')"
                class="btn"
                :title="
                  $anm22.strLang(
                    lang,
                    'Confirm payment without printing',
                    'Conferma pagamento senza stampa'
                  )
                "
                @click="
                  payOrder('noPrint');
                  showPrtModal = false;
                "
              />
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(
                    lang,
                    "Pay without printing",
                    "Paga senza stampa"
                  )
                }}
              </div>
            </div>
            <div 
                v-if="accessControl.deleteOrder"
                class="display-flex action-btn-with-desc">
              <img
                :src="$anm22.icons.getWorldIcon('deleteRed')"
                class="btn"
                :title="$anm22.strLang(lang, 'Delete order', 'Cancella ordine')"
                @click="
                  deleteOrder();
                  showPrtModal = false;
                "
              />
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Delete", "Elimina") }}
              </div>
            </div>
          </div>
          <template v-if="showInvoiceSeriesError">
            <div class="vertical-height-div" style="height: 10px"></div>
            <div class="wg-row" style="justify-content: center">
              <div
                class="com-anm22-app-text-m"
                style="color: red; text-align: center"
              >
                {{
                  $anm22.strLang(
                    lang,
                    "Cannot emit invoice because no series has been selected.",
                    "Non è possibile emettere fattura poichè nessun sezionale è stato selezionato."
                  )
                }}
              </div>
            </div>
          </template>
        </div>
      </wg-modal>
      <!-- only fiscal enabled -->
      <wg-modal
        v-if="license.config.modules.fiscal.enabled && showFisPrintModal"
        @closeModal="showFisPrintModal = false"
      >
        <div
          slot="body"
          class="wg-row"
          style="flex-direction: column; align-items: center"
        >
          <div class="com-anm22-app-text-xxl">
            {{ $anm22.strLang(lang, "Print", "Stampa") }}
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div
            class="wg-row"
            style="flex-wrap: nowrap; justify-content: space-around"
          >
            <div
              v-for="(printer, index) in printers.filter(
                (p) => p.printMode.fis
              )"
              :key="'printer-fis-' + index"
              class="display-flex action-btn-with-desc"
            >
              <img
                :src="$anm22.icons.getWorldIcon('printf')"
                class="btn print-button-fis"
                :title="printer.name"
                @click="
                  print(printer.idPrinter, 'fis');
                  showFisPrintModal = false;
                "
              />
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="com-anm22-app-text-m">{{ printer.name }}</div>
            </div>
          </div>
        </div>
      </wg-modal>
      <!-- LOTTERY ID MODAL -->
      <wg-modal v-if="showLotteryModal" @closeModal="showLotteryModal = false">
        <div
          slot="body"
          class="wg-row"
          style="flex-direction: column; align-items: center"
        >
          <div class="com-anm22-app-text-xxl">
            {{
              $anm22.strLang(
                lang,
                "Would you like to insert a lottery ID?",
                "Si vuole inserire un Codice Lotteria?"
              )
            }}
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div
            v-if="lotteryData.error"
            class="wg-row"
            style="flex-wrap: nowrap; justify-content: space-around"
          >
            <div class="com-anm22-app-text-l" style="color: red">
              {{
                $anm22.strLang(
                  lang,
                  "Lottery ID must be 8 alphanumeric digits",
                  "Il Codice Lotteria deve essere alfanumerico a 8 cifre"
                )
              }}
            </div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div
            class="wg-row"
            style="flex-wrap: nowrap; justify-content: space-around"
          >
            <input 
                type="text" 
                v-model="lotteryData.lotteryCode"
                @focus="pauseKeyboardListener = true"
                @blur="pauseKeyboardListener = false"
            />
          </div>
          <div class="vertical-height-div" style="height: 20px"></div>
          <button class="small" @click="confirmLottery">
            <div class="com-anm22-app-text-l">
              {{ $anm22.strLang(lang, "Confirm", "Conferma") }}
            </div>
          </button>
        </div>
      </wg-modal>
      <!-- PRINTER MANAGE MODAL -->
      <wg-modal
        v-if="showManagePrintersModal"
        @closeModal="showManagePrintersModal = false"
      >
        <div
          slot="body"
          class="wg-row"
          style="flex-direction: column; align-items: center"
        >
          <div class="com-anm22-app-text-xxl">
            {{ $anm22.strLang(lang, "Manage printers", "Gestione stampanti") }}
          </div>
          <div class="vertical-height-div" style="height: 20px"></div>
          <template
            v-for="(printer, index) in printers.filter((p) => p.printMode.fis)"
          >
            <div
              :key="'p-man-fis-name-' + index"
              class="com-anm22-app-text-xxl"
            >
              {{ printer.name }}
            </div>
            <div
              :key="'p-man-fis-space-pre-' + index"
              class="vertical-height-div"
              style="height: 10px"
            ></div>
            <div
              :key="'p-man-fis-opts-' + index"
              class="wg-row"
              style="flex-wrap: nowrap; align-items: center"
            >
              <div
                class="display-flex action-btn-with-desc"
                @click="printFinancialReport(printer.idPrinter)"
              >
                <div
                  class="com-anm22-app-text-m btn display-flex"
                  style="
                    flex-wrap: nowrap;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  {{
                    $anm22.strLang(
                      lang,
                      "Financial report",
                      "Report finanziario"
                    )
                  }}
                </div>
              </div>
              <div
                class="display-flex action-btn-with-desc"
                @click="printDailyClosure(printer.idPrinter)"
              >
                <div
                  class="com-anm22-app-text-m btn display-flex"
                  style="
                    flex-wrap: nowrap;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  {{
                    $anm22.strLang(
                      lang,
                      "Dayly closing",
                      "Chiusura giornaliera"
                    )
                  }}
                </div>
              </div>
              <div
                class="display-flex action-btn-with-desc"
                @click="openPrintReceiptsModal(printer.idPrinter)"
              >
                <div
                  class="com-anm22-app-text-m btn display-flex"
                  style="
                    flex-wrap: nowrap;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  {{
                    $anm22.strLang(lang, "Print receipts", "Stampa scontrini")
                  }}
                </div>
              </div>
              <div
                class="display-flex action-btn-with-desc"
                @click="openCancelReceiptModal(printer.idPrinter)"
              >
                <div
                  class="com-anm22-app-text-m btn display-flex"
                  style="
                    flex-wrap: nowrap;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  {{
                    $anm22.strLang(lang, "Cancel receipt", "Annulla scontrino")
                  }}
                </div>
              </div>
            </div>
            <div
              :key="'p-man-fis-space-post-' + index"
              class="vertical-height-div"
              style="height: 20px"
            ></div>
          </template>
        </div>
      </wg-modal>
      <!-- PRINT RECEIPTS MODAL -->
      <wg-modal
        v-if="showPrintReceiptsModal"
        @closeModal="closePrintReceiptsModal"
      >
        <div
          slot="body"
          class="wg-row"
          style="flex-direction: column; align-items: center"
        >
          <div class="com-anm22-app-text-xxl">
            {{
              $anm22.strLang(
                lang,
                "Print fiscal receipts",
                "Stampa ricevute fiscali"
              )
            }}
          </div>
          <div class="vertical-height-div" style="height: 20px"></div>
          <input
            ref="printReceiptsDate"
            type="date"
            :value="$moment.tz(timezone).format('YYYY-MM-DD')"
            @focus="pauseKeyboardListener = true"
            @blur="pauseKeyboardListener = false"
          />
          <div class="vertical-height-div" style="height: 20px"></div>
          <input
            type="button"
            :value="$anm22.strLang(lang, 'Confirm', 'Conferma')"
            @click="printReceipts"
          />
        </div>
      </wg-modal>
      <!-- CANCEL RECEIPT MODAL -->
      <wg-modal
        v-if="showCancelReceiptModal"
        @closeModal="closeCancelReceiptModal"
      >
        <div
          slot="body"
          class="wg-row"
          style="flex-direction: column; align-items: center"
        >
          <div class="com-anm22-app-text-xxl">
            {{
              $anm22.strLang(
                lang,
                "Cancel fiscal receipt",
                "Annulla ricevuta fiscale"
              )
            }}
          </div>
          <div class="vertical-height-div" style="height: 20px"></div>
          <input
            ref="cancelReceiptCode"
            type="text"
            value=""
            placeholder="0000-0000"
            @focus="pauseKeyboardListener = true"
            @blur="pauseKeyboardListener = false"
          />
          <div class="vertical-height-div" style="height: 20px"></div>
          <input
            ref="cancelReceiptDate"
            type="date"
            :value="$moment.tz(timezone).format('YYYY-MM-DD')"
            @focus="pauseKeyboardListener = true"
            @blur="pauseKeyboardListener = false"
          />
          <div class="vertical-height-div" style="height: 20px"></div>
          <input
            type="button"
            :value="$anm22.strLang(lang, 'Confirm', 'Conferma')"
            @click="cancelReceipt"
          />
        </div>
      </wg-modal>
      <!-- PRINTER MANAGE MODAL -->
      <wg-modal v-if="showDrawersModal" @closeModal="showDrawersModal = false">
        <div
          slot="body"
          class="wg-row"
          style="flex-direction: column; align-items: center"
        >
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="com-anm22-app-text-xxl">
            {{
              $anm22.strLang(
                lang,
                "Open printer drawer",
                "Apri cassetto stampante"
              )
            }}
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div
            v-for="(printer, index) in printers.filter(
              (p) => p.printMode.fis && p.model == 21
            )"
            :key="'printer-fis-ticket-' + index"
            class="display-flex action-btn-with-desc"
          >
            <img
              :src="$anm22.icons.getWorldIcon('printf')"
              class="btn print-button-fis"
              :title="printer.name"
              @click="openDrawer(printer.idPrinter)"
            />
            <div class="vertical-height-div" style="height: 5px"></div>
            <div class="com-anm22-app-text-m">{{ printer.name }}</div>
          </div>
        </div>
      </wg-modal>
      <!-- INVOICE MODAL -->
      <wg-modal
        :width="windowWidth > 772 ? '700px' : '90%'"
        v-if="showInvoiceModal"
        @closeModal="closeInvoiceModal"
      >
        <div slot="header" class="com-anm22-app-text-xxl">
          {{ $anm22.strLang(lang, "Invoice management", "Gestione fatture") }}
        </div>
        <invoice
          slot="body"
          :order="order"
          :amountToPay="totalToPay"
          :payments="payments"
          :paymentId="invPayment"
          :invoiceId="invInvoice"
          :printers="printers.filter((p) => p.printMode.text)"
          @pay="payOrderFromInvoice"
        ></invoice>
      </wg-modal>
      <div
        class="wg-row"
        style="justify-content: space-between; align-items: center"
      >
        <div
          class="wg-col wg-xs-12 wg-md-7 fc-product-div-new"
          :style="sepBillMode ? { opacity: '0.3', pointerEvents: 'none' } : ''"
        >
          <mobile-title-bar
            :order="order"
            @open-cart="openCart"
            @open-cover-modal="showCoverModal = true"
          ></mobile-title-bar>
          <template v-if="showExtensionAlert">
            <div
              v-if="deviceSpecs.browser === 'gc'"
              class="wg-row extension-alert"
              @click="installChromeExtension"
            >
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(
                    lang,
                    "To use printers, download the newest Chrome extension clicking this message.",
                    "Per utilizzare le stampanti installare l'estensione Chrome più recente cliccando su questo messaggio."
                  )
                }}
              </div>
              <img
                :src="$anm22.icons.getWorldIcon('chromeWebStore')"
                style="
                  margin-left: 5px;
                  height: 44px;
                  border-radius: 6px;
                  background-color: #fff;
                "
              />
            </div>
            <div v-else class="wg-row no-printers-alert">
              <div class="com-anm22-app-text-l">
                {{
                  $anm22.strLang(
                    lang,
                    "To use printers, download the newest Chrome extension clicking this message.",
                    "Per utilizzare le stampanti installare l'estensione Chrome più recente cliccando su questo messaggio."
                  )
                }}
              </div>
            </div>
          </template>
          <div
            class="com-anm22-food-scrolling-panel"
            :style="{ height: productsHeight + 'px' }"
          >
            <products
              :style="{ height: '100%' }"
              :elements="elements"
              @add-element="addElement"
            ></products>
          </div>
        </div>
        <div
          :class="[
            'wg-xs-12',
            'wg-md-5',
            'com-anm22-food-scrolling-panel',
            'com-anm22-food-fc-control-panel-new',
            cartOpen === null ? '' : cartOpen ? 'slide-in' : 'slide-out',
          ]"
          style="padding: 0"
        >
          <!-- CONTO SEPARATO - DIV A SCOMPARSA -->
          <div class="wg-row sep-bill-container">
            <div
              :class="[
                'wg-row',
                'fc-sp-div',
                sepBillMode === null
                  ? ''
                  : sepBillMode
                  ? 'slide-in'
                  : 'slide-out',
              ]"
              :style="{
                minHeight: '298px',
                height: sepDivHeight + 'px',
                border: '1px solid #ddd',
              }"
            >
              <sep-bill
                :license="license"
                :order="order"
                :elements="toPay"
                :tables="tables"
                :printers="printers"
                :accessControl="accessControl"
                :action="sepBillAction"
                @close="sepBillMode = false"
                @select-input="selectInput($event.event, $event.callback)"
                @pay-sep="paySepBill('noPrint', $event)"
                @print-sep="printSep($event)"
                @print-sep-ticket="printSepTicket($event)"
                @print-invoice-sep="printInvoiceSep($event)"
              ></sep-bill>
            </div>
          </div>
          <!-- LISTA ARTICOLI -->
          <div class="no-select fc-cp-articles">
            <div
              class="wg-row wg-md-none"
              style="
                height: 40px;
                flex-wrap: nowrap;
                align-items: flex-end;
                justify-content: flex-end;
              "
            >
              <div
                class="com-anm22-app-text-l"
                style="
                  cursor: pointer;
                  border: 1px solid #ccc;
                  padding: 5px;
                  border-radius: 4px;
                  margin-right: 10px;
                "
                @click="closeCart"
              >
                {{ $anm22.strLang(lang, "Close", "Chiudi") }}
              </div>
            </div>
            <div
              class="wg-row wg-p-xs-20 com-anm22-food-scrolling-panel"
              :style="{
                flexDirection: 'column',
                flexWrap: 'nowrap',
                minHeight: '140px',
                height: cartHeight + 'px',
              }"
            >
              <div style="width: 100%; flex: 2">
                <div
                  v-if="order.covers[0].filter((c) => !c).length > 0"
                  class="wg-row"
                  style="margin-bottom: 5px; font-size: 18px"
                >
                  <div style="margin-right: 5px">
                    {{ order.covers[0].filter((c) => !c).length + "x" }}
                  </div>
                  <div>{{ $anm22.strLang(lang, "Cover", "Coperto") }}</div>
                  <div style="margin-left: auto">
                    {{
                      Number(
                        order.covers[0].filter((c) => !c).length *
                          order.covers[1]
                      ).toFixed(2) + " €"
                    }}
                  </div>
                </div>
                <template v-for="s in order.maxSequence">
                  <div
                    v-if="license.config.modules.sequences.enabled"
                    :key="'sequence-' + s"
                    class="sequence-div wg-row com-anm22-food-seq-div"
                    @click="selectSequence(s)"
                    :style="{ color: sequence === s ? '#2196F3' : '#ccc' }"
                  >
                    <div class="com-anm22-app-text-l">
                      {{
                        $anm22.strLang(lang, "Sequence", "Sequenza") + " " + s
                      }}
                    </div>
                    <img
                      v-if="s <= order.printedSequence"
                      :src="$anm22.icons.getWorldIcon('runningMan')"
                      class="com-anm22-app-img-fixed-height-s"
                      style="margin-left: 10px"
                    />
                  </div>
                  <item-row
                    v-for="(row, index) in toPayRows[s]"
                    :key="s + '-row-' + index"
                    :row="row"
                    @select-input="
                      selectInput($event.event, $event.callback, $event.data)
                    "
                    @delete-article="deleteArticle"
                  ></item-row>
                  <div
                    :key="s + '-row-space-after'"
                    class="vertical-height-div"
                    style="height: 10px"
                  ></div>
                </template>
              </div>
              <div class="vertical-height-div" style="height: 10px"></div>
              <!-- PAGATO -->
              <div
                v-if="payed.length > 0"
                class="wg-row com-anm22-app-text-l"
                style="padding-bottom: 2px; border-bottom: 1px solid #ccc"
              >
                {{ $anm22.strLang(lang, "Payed", "Pagato") }}
              </div>
              <div v-if="payed.length > 0" style="width: 100%; flex: 2">
                <div
                  v-if="order.covers[0].filter((c) => c).length > 0"
                  class="wg-row"
                  style="margin-top: 12px; font-size: 18px"
                >
                  <div style="margin-right: 5px">
                    {{ order.covers[0].filter((c) => c).length + "x" }}
                  </div>
                  <div>{{ $anm22.strLang(lang, "Cover", "Coperto") }}</div>
                  <div style="margin-left: auto">
                    {{
                      Number(
                        order.covers[0].filter((c) => c).length *
                          order.covers[1]
                      ).toFixed(2) + "€"
                    }}
                  </div>
                </div>
                <item-row
                  v-for="(row, index) in payedRows"
                  :key="'payed-row-' + index"
                  :row="row"
                ></item-row>
              </div>
            </div>
            <div
              class="wg-row no-select"
              style="
                flex-wrap: nowrap;
                align-items: center;
                justify-content: space-between;
                padding: 5px 10px;
              "
            >
              <div
                class="display-flex action-btn"
                @click="showClearListModal = true"
                :title="$anm22.strLang(lang, 'Empty cart', 'Svuota carrello')"
              >
                <img
                  :src="$anm22.icons.getWorldIcon('emptyCart')"
                  class="com-anm22-app-img-fixed-height-l"
                />
              </div>
              <div
                v-if="license.config.modules.tables.enabled"
                class="display-flex action-btn"
                @click="showCoverModal = true"
                :title="$anm22.strLang(lang, 'Covers', 'Coperti')"
              >
                <img
                  :src="$anm22.icons.getWorldIcon('multiUser')"
                  class="com-anm22-app-img-fixed-height-l"
                />
              </div>
              <template v-if="license.config.modules.sequences.enabled">
                <div
                  class="display-flex action-btn"
                  @click="newSequence"
                  :title="
                    $anm22.strLang(lang, 'New sequence', 'Nuova sequenza')
                  "
                >
                  <img
                    :src="$anm22.icons.getWorldIcon('listAdd')"
                    class="com-anm22-app-img-fixed-height-l"
                  />
                </div>
                <div
                  v-if="license.printSequences"
                  :class="[
                    'display-flex',
                    'action-btn',
                    saved && order.printedSequence < order.maxSequence
                      ? ''
                      : 'disabled',
                  ]"
                  @click="nextSequence"
                  :title="
                    $anm22.strLang(
                      lang,
                      'Next course',
                      'Marcia prossima sequenza'
                    )
                  "
                >
                  <img
                    :src="$anm22.icons.getWorldIcon('arrowRight')"
                    class="com-anm22-app-img-fixed-height-l"
                  />
                </div>
              </template>
              <div
                v-if="accessControl.payOrder"
                :class="[
                  'display-flex',
                  'action-btn',
                  totalToPay > 0 ? '' : 'disabled',
                ]"
                :title="$anm22.strLang(lang, 'Split bill', 'Conto separato')"
                @click="totalToPay > 0 ? (sepBillMode = true) : ''"
              >
                <img
                  :src="$anm22.icons.getWorldIcon('split')"
                  class="com-anm22-app-img-fixed-height-l"
                />
              </div>
              <div
                class="display-flex action-btn"
                @click="showNotesModal = true"
                :title="$anm22.strLang(lang, 'Notes', 'Note')"
              >
                <img
                  :src="$anm22.icons.getWorldIcon('sheet')"
                  class="com-anm22-app-img-fixed-height-l"
                />
              </div>
            </div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="wg-row" style="padding: 0 10px 0 10px">
            <div
              v-if="order.deliveryPrice"
              class="wg-row"
              :style="{
                alignItems: 'baseline',
                marginBottom: '4px',
                flexWraps: 'nowrap',
                alignItems: 'center',
              }"
            >
              <div
                class="wg-col wg-xs-6 display-flex"
                style="flex-wrap: nowrap; align-items: center"
              >
                <label
                  v-if="!order.deliveryPayment"
                  class="com-anm22-app-pointer fc-delivery-label"
                  style="margin: 0 5px 0 0; object-fit: contain"
                >
                  <img
                    v-if="!ignoreDeliveryPrice"
                    :src="$anm22.icons.getWorldIcon('tick')"
                    style="height: 100%; width: 100%"
                  />
                  <input
                    type="checkbox"
                    id="delivery-checkbox"
                    @change="ignoreDeliveryPrice = !ignoreDeliveryPrice"
                    style="display: none"
                    :disabled="order.deliveryPayment !== ''"
                  />
                </label>
                <div class="com-anm22-app-text-xl">
                  {{
                    $anm22.strLang(lang, "Delivery cost:", "Costo di consegna:")
                  }}
                </div>
              </div>
              <div
                class="wg-col wg-xs-6 display-flex"
                style="
                  flex-wrap: nowrap;
                  align-items: center;
                  justify-content: flex-end;
                "
              >
                <div class="com-anm22-app-text-xl">
                  {{ order.deliveryPrice.toFixed(2) }}
                </div>
                <div class="com-anm22-app-text-xl" style="margin-left: 12px">
                  EUR
                </div>
              </div>
            </div>
            <div
              class="wg-row"
              style="align-items: baseline; margin-bottom: 4px"
            >
              <div class="wg-col wg-xs-6">
                <div class="com-anm22-app-text-xl">
                  {{ $anm22.strLang(lang, "Discount:", "Sconto:") }}
                </div>
              </div>
              <div
                class="wg-col wg-xs-6 display-flex"
                style="
                  flex-wrap: nowrap;
                  align-items: center;
                  justify-content: flex-end;
                "
              >
                <input
                  readonly
                  type="text"
                  class="com-anm22-app-align-right"
                  style="
                    width: 100px;
                    font-size: 18px;
                    height: 24px;
                    padding: 2px;
                  "
                  :value="Number(order.discount).toFixed(2)"
                  @focus="selectInput($event, 'setDiscount')"
                />
                <div class="com-anm22-app-text-xl" style="margin-left: 32px">
                  %
                </div>
              </div>
            </div>
            <template v-if="order.surcharge">
              <div
                class="wg-row"
                style="align-items: baseline; margin-bottom: 4px"
              >
                <div class="wg-col wg-xs-6">
                  <div class="com-anm22-app-text-xl">
                    {{
                      $anm22.strLang(
                        lang,
                        "Service cost:",
                        "Costo di servizio:"
                      )
                    }}
                  </div>
                </div>
                <div
                  class="wg-col wg-xs-6 display-flex"
                  style="
                    flex-wrap: nowrap;
                    align-items: center;
                    justify-content: flex-end;
                  "
                >
                  <div class="com-anm22-app-text-xl" id="totalOrder">
                    {{ order.surcharge.toFixed(2) }}
                  </div>
                  <div class="com-anm22-app-text-xl" style="margin-left: 12px">
                    EUR
                  </div>
                </div>
              </div>
            </template>
            <div
              class="wg-row"
              style="align-items: baseline; margin-bottom: 8px"
            >
              <div class="wg-col wg-xs-6">
                <div class="com-anm22-app-text-xl">
                  {{ $anm22.strLang(lang, "To pay:", "Da pagare:") }}
                </div>
              </div>
              <div
                class="wg-col wg-xs-6 display-flex"
                style="
                  flex-wrap: nowrap;
                  align-items: center;
                  justify-content: flex-end;
                "
              >
                <input
                  readonly
                  type="text"
                  :class="[
                    'com-anm22-app-align-right',
                    totalToPay < 0 ? 'price-sub-zero' : '',
                  ]"
                  style="
                    width: 100px;
                    font-size: 18px;
                    height: 24px;
                    padding: 2px;
                  "
                  :value="totalToPay.toFixed(2)"
                  @focus="selectInput($event, 'setCustomToPay')"
                />
                <div class="com-anm22-app-text-xl" style="margin-left: 10px">
                  EUR
                </div>
              </div>
            </div>
            <div
              class="wg-row"
              style="align-items: baseline; margin-bottom: 8px"
            >
              <div class="wg-col wg-xs-6">
                <div class="com-anm22-app-text-xl">
                  {{ $anm22.strLang(lang, "Total:", "Totale:") }}
                </div>
              </div>
              <div
                class="wg-col wg-xs-6 display-flex"
                style="
                  flex-wrap: nowrap;
                  align-items: center;
                  justify-content: flex-end;
                "
              >
                <div class="com-anm22-app-text-xl" id="totalOrder">
                  {{ totalOrder.toFixed(2) }}
                </div>
                <div class="com-anm22-app-text-xl" style="margin-left: 12px">
                  EUR
                </div>
              </div>
            </div>
          </div>
          <!-- Campo per l'utilizzo di scorciatoie tramite tastierino -->
          <div class="wg-row code-string-div">
            <div
              class="display-flex com-anm22-app-text-l clear-btn"
              @click="codeString = ''"
            >
              CL
            </div>
            <div style="margin-left: auto">{{ codeString }}</div>
          </div>
          <div class="com-anm22-app-horizontal-line-light"></div>
          <keypad :layout="layout" @keypad-pressed="keyPressed"></keypad>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import CoverModal from "../../components/employee/CoverModal.vue";
import VarModal from "../../components/employee/VarModal.vue";
import MobileTitleBar from "../../components/employee/MobileTitleBar.vue";
import Products from "../../components/employee/Products.vue";
import ItemRow from "../../components/employee/FastCashItemRow.vue";
import TablesManage from "../../components/tables/TablesManage.vue";
import YbMap from "../../components/YbMap.vue";
import SepBill from "../../components/employee/SepBill.vue";
import Keypad from "../../components/employee/Keypad.vue";
import Invoice from "../../components/employee/Invoice.vue";
import Anm22PayCard from "../../components/Anm22PayCard.vue";
import Anm22Board from "../../../../../world/spa/components/Anm22Board.vue";

export default {
  components: {
    "vue-simple-spinner": Spinner,
    CoverModal,
    MobileTitleBar,
    Products,
    ItemRow,
    TablesManage,
    VarModal,
    YbMap,
    SepBill,
    Keypad,
    Invoice,
    Anm22PayCard,
    Anm22Board
  },
  data() {
    return {
      loading: true,
      updating: false,
      printing: false,
      saved: false,
      /* Apertura carrello (mobile) */
      cartOpen: null,
      /* Supporto */
      sequence: 1,
      /* Variabili per costi di consegna */
      ignoreDeliveryPrice: false,
      /* Ordine ed elementi - vengono gestiti in copia dallo store o ex novo */
      order: null,
      elements: [],
      /* Conto separato */
      sepBillMode: null,
      sepBillData: null,
      sepBillAction: "",
      /* Coperti */
      showCoverModal: false,
      /* Variazioni */
      showVarModal: false,
      varModalElement: null,
      /* PIN AUTH */
      pin: "",
      /* */
      showClearListModal: false,
      showNotesModal: false,
      /* Payment modal */
      showPaymentModal: false,
      paymentTempSelect: null,
      /* Payment with Anm22 Pay */
      payInputName: "",
      payInputEmail: "",
      payInputNumber: "",
      loadingPayHints: false,
      payHints: [],
      selectedCard: null,
      /* Delivery modal */
      showDeliveryModal: false,
      deliveryTempSelect: null,
      ybModalMode: "",
      ybModalDeliveryType: 0,
      ybSelectRef: null,
      showYbInstantModal: false,
      showYbSignModal: false,
      ybSignature: null,
      /* Printers */
      showPrtModal: false,
      showFisPrintModal: false,
      showManagePrintersModal: false,
      selectedPrinter: null,
      showPrintReceiptsModal: false,
      showCancelReceiptModal: false,
      showLotteryModal: false,
      lotteryData: {
        error: false,
        lotteryCode: null,
        function: null,
        functionArgs: null,
      },
      /* Aggiornamento quantità prodotti */
      productTimer: null,
      /* Gestione scorciatoie keypad */
      codeString: "",
      inputSelected: null,
      inputCallback: null,
      inputAdditionalData: null,
      pauseKeyboardListener: false,
      /* Fatture */
      showInvoiceModal: false,
      invPayment: null,
      invInvoice: null,
      showInvoiceSeriesError: false,
      /* Popup apertura cassetti stampanti */
      showDrawersModal: false,
      // Gestione contatto
      contact: null,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      licenseSelected: (state) => state.licenseSelected,
      windowWidth: (state) => state.windowWidth,
      windowHeight: (state) => state.windowHeight,
      isOffline: (state) => state.offline.isOffline,
      appColor: (state) => state.config.appColor,
      deviceSpecs: (state) => state.deviceSpecs,
    }),
    showExtensionAlert() {
      if (
        this.deviceSpecs.browser === "gc" &&
        !this.deviceSpecs.mobile &&
        this.$anm22.getCookie("anm22_world_app_mode") === ""
      ) {
        return (
          window.chromeExtensionEnable !== "fd" ||
          window.chromeExtensionId !== "deoglaoecglnimkaggbbgdkmhbdfgjid"
        );
      } else {
        return false;
      }
    },
    productsHeight() {
      return (
        this.windowHeight -
        (this.windowWidth >= 992 ? 60 : 105) -
        (this.showExtensionAlert ? 50 : 0)
      );
    },
    cartHeight() {
      return (
        this.windowHeight -
        (this.windowWidth >= 992 ? 500 : 540) -
        (this.order.deliveryPrice ? 26 : 0) -
        (this.order.surcharge ? 22 : 0)
      );
    },
    sepDivHeight() {
      return this.windowHeight - (this.windowWidth >= 992 ? 341 : 291);
    },
    layout() {
      return [
        "7",
        "8",
        "9",
        {
          key: "-",
          icon: this.$anm22.icons.getWorldIcon("dash"),
        },
        {
          key: "payment",
          icon: this.paymentBtnIcon,
          label: this.paymentBtnLabel,
          fn: this.openPaymentModal,
          imgStyle: this.getPmStyle(this.$anm22.tableClasses.worldPaymentModeType().getById(this.order.paymentMethod)),
        },
        "4",
        "5",
        "6",
        {
          key: "confirm",
          icon: this.$anm22.icons.getWorldIcon("tick"),
          fn: this.save,
          disabled: this.sepBillMode,
        },
        {
          key: "delivery",
          icon: this.deliveryBtnIcon,
          label: this.deliveryBtnLabel,
          fn: this.openDeliveryModal,
          disabled: this.sepBillMode,
        },
        "1",
        "2",
        "3",
        {
          key: "prt",
          // icon: this.$anm22.icons.getWorldIcon("print"),
          style: {
            fontSize: "20px",
            fontWeight: "bold",
          },
          label: "PRT",
          dims: [2, 1],
          fn: this.prtButton,
        },
        {
          key: "fis",
          // icon: this.$anm22.icons.getWorldIcon("printf"),
          style: {
            color: "#fff",
            fontSize: "20px",
            fontWeight: "bold",
            backgroundColor: "#2196f3",
          },
          label: "TOT",
          dims: [2, 1],
          fn: this.fisButton,
          disabled:
            !this.license.config.modules.fiscal.enabled ||
            !this.hasFiscalPrinters ||
            (this.order.payed && this.order.receiptType),
        },
        "x",
        "0",
        ".",
      ];
    },
    license() {
      return this.$store.getters["foodLicenses/getByHash"](
        this.licenseSelected
      );
    },
    canEmitInvoice() {
      return !!this.license.documentSeries;
    },
    work() {
      return this.$store.getters["works/get"](this.license.work);
    },
    timezone() {
      return this.work.timezone;
    },
    paymentMethods() {
      const pms = this.license.paymentMethods
        .filter((p) => p.admin || p.customer)
        .map((p) => p.id);
      pms.push(2);
      return pms;
    },
    paymentBtnIcon() {
      if (this.order.paymentMethod) {
        const pm = this.$anm22.tableClasses
          .worldPaymentModeType()
          .getById(this.order.paymentMethod);
        return this.$anm22.icons.getWorldIcon(
          "payment" + this.$anm22.capitalizeFirst(pm.typeClassLiteral)
        );
      } else {
        return this.$anm22.icons.getWorldIcon("paymentCash");
      }
    },
    paymentBtnLabel() {
      let string = "";
      const pm = this.$anm22.tableClasses
        .worldPaymentModeType()
        .getById(this.order.paymentMethod);
      if (pm.typeClass === 7) {
        string = this.order.paymentData.umbrella;
      }
      return string;
    },
    deliveryTypes() {
      return this.license.deliveryTypes
        .filter((dt) => dt.admin || dt.customer)
        .map((d) => d.id);
    },
    deliveryPrices() {
      return this.license.deliveryPrices;
    },
    deliveryBtnIcon() {
      if (this.order.deliveryType) {
        const dt = this.$anm22.tableClasses
          .worldDeliveryType()
          .getById(this.order.deliveryType);
        return this.$anm22.icons.getWorldIcon(dt.typeClassLiteral);
      } else {
        return this.$anm22.icons.getWorldIcon("pickUpBar");
      }
    },
    deliveryBtnLabel() {
      switch (this.order.deliveryType) {
        case 1:
        case 2:
          const beaches = this.$store.getters["ybLicenses/getByLicense"](
            this.license.id
          );
          if (beaches.length > 1) {
            const beach = this.$store.getters["works/get"](this.order.beach);
            return beach.name + " - " + this.order.beachUmbrella;
          } else {
            return this.order.beachUmbrella;
          }
          break;
        case 5:
          const table = this.tables.find((t) => t.id === this.order.tableRef);
          return this.order.tableAlias || table.name;
          break;
        case 9:
          return this.order.pickUpPoint[this.lang];
          break;
        default:
          return "";
      }
    },
    employment() {
      return this.$store.getters["foodEmployments/get"](
        this.license.id + "-" + this.user.idWorldUser
      );
    },
    permission() {
      return this.employment.permission;
    },
    accessControl() {
      return this.$store.getters["foodAcs/get"](
        this.license.id + "-" + this.permission
      );
    },
    products() {
      return this.$store.getters["foodProducts/getByLicense"](
        this.license.id
      ).filter((p) => !p.deleted);
    },
    rooms() {
      return this.$store.getters["foodRooms/getByLicense"](
        this.license.id
      ).filter((r) => !r.deleted);
    },
    tables() {
      return this.$store.getters["foodTables/getByLicense"](
        this.license.id
      ).filter((t) => !t.deleted);
    },
    printers() {
      return this.$store.getters["foodPrinters/getByLicense"](
        this.license.id
      ).filter((p) => p.printMode.fis || p.printMode.nfis);
    },
    hasFiscalPrinters() {
      return this.printers.filter((p) => p.printMode.fis).length > 0;
    },
    /* ARRAY DI GESTIONE DEGLI ELEMENTI DELL'ORDINE */
    toPay: function () {
      return this.elements
        .filter((e) => !e.payment)
        .sort((a, b) => a.product - b.product);
    },
    toPayRows: function () {
      /* Key: seq, val: rows */
      let maxSequence = 0;
      let result = [];
      for (let i = 1; i <= this.order.maxSequence; i++) {
        result[i] = [];
      }
      this.toPay.forEach((e) => {
        const sequence = e.sequence;
        if(sequence > maxSequence) {
          maxSequence = sequence;
        }
        if(!result[sequence]) {
          result[sequence] = [];
        }
        if (e.weight === "") {
          // Raggruppamento in riga se non ho variazioni o tariffazione a peso
          if (e.variations.length === 0) {
            /* cerco se una riga con questo prodotto è già presente nell'array */
            const found = result[sequence].findIndex(
              (row) =>
                row.elem.product === e.product &&
                row.elem.variations.length === 0
            );
            /* Se esiste aggiorno la riga altrimenti la creo e la aggiungo */
            if (-1 !== found) {
              result[sequence][found].elem = e;
              result[sequence][found].onclick = this.openVarModal;
              result[sequence][found].quantity++;
              result[sequence][found].price += e.price;
            } else {
              result[sequence].push({
                elem: e,
                weightEdit: null,
                priceEdit: true,
                deletable: true,
                onclick: this.openVarModal,
                quantity: 1,
                weight: null,
                price: e.price,
              });
            }
          } else {
            result[sequence].push({
              elem: e,
              weightEdit: null,
              priceEdit: true,
              deletable: true,
              onclick: this.openVarModal,
              quantity: 1,
              weight: null,
              price: e.price,
            });
          }
        } else {
          result[sequence].push({
            elem: e,
            weightEdit: true,
            priceEdit: true,
            deletable: true,
            onclick: this.openVarModal,
            quantity: 1,
            weight: e.weight,
            price: e.price,
          });
        }
      });
      // Fix any inconsistency betweene sequence of elements and maxSequence
      if(this.order.maxSequence < maxSequence) {
        this.order.maxSequence = maxSequence;
      }
      return result;
    },
    payed: function () {
      return this.elements
        .filter((e) => e.payment)
        .sort((a, b) => a.product - b.product);
    },
    payedRows: function () {
      let result = [];
      this.payed.forEach((e) => {
        if (e.weight === "") {
          if (e.variations.length === 0) {
            /* cerco se una riga con questo prodotto è già presente nell'array */
            const found = result.findIndex(
              (row) =>
                row.elem.product === e.product &&
                row.elem.variations.length === 0
            );
            /* Se esiste aggiorno la riga altrimenti la creo e la aggiungo */
            if (-1 !== found) {
              result[found].elem = e;
              result[found].quantity++;
              result[found].price += e.price;
            } else {
              result.push({
                elem: e,
                weightEdit: null,
                priceEdit: false,
                deletable: false,
                onclick: false,
                quantity: 1,
                weight: null,
                price: e.price,
              });
            }
          } else {
            result.push({
              elem: e,
              weightEdit: null,
              priceEdit: false,
              deletable: false,
              onclick: false,
              quantity: 1,
              weight: null,
              price: e.price,
            });
          }
        } else {
          result.push({
            elem: e,
            weightEdit: false,
            priceEdit: false,
            deletable: false,
            onclick: false,
            quantity: 1,
            weight: e.weight,
            price: e.price,
          });
        }
      });
      return result;
    },
    /* TOTALI */
    totalArticles() {
      let result = 0;
      //Articoli + variazioni
      this.toPay.forEach((e) => {
        result += e.price;
        e.variations.forEach((v) => {
          result += v.price;
        });
      });
      //Coperti
      result +=
        this.order.covers[0].filter((c) => !c).length * this.order.covers[1];
      //Costo di consegna
      if (
        this.order.deliveryPrice &&
        !this.order.deliveryPayment &&
        !this.ignoreDeliveryPrice
      ) {
        result += this.order.deliveryPrice;
      }
      return this.$anm22.round(result, 2);
    },
    totalToPay() {
      // Non consideriamo mai i sovrapprezzi nella cassa rapida
      return this.$anm22.round(
        this.totalArticles - (this.totalArticles / 100) * this.order.discount,
        2
      );
    },
    totalOrder() {
      return this.$anm22.round(
        this.totalToPay + Number(this.order.payedTotal),
        2
      );
    },
    cmds() {
      return [
        {
          regex: /\d+x-?\d+/i,
          fn: (string) => {
            const tokenized = string.split("x");
            return {
              qnt: Number(tokenized[0]),
              price: Number(tokenized[1]),
            };
          },
        },
        {
          regex: /\d+x/i,
          fn: (string) => {
            const tokenized = string.split("x");
            return {
              qnt: Number(tokenized[0]),
            };
          },
        },
        {
          regex: /\d+/i,
          fn: (string) => {
            return {
              price: Number(string),
            };
          },
        },
      ];
    },
    payments() {
      return this.$store.getters["foodPayments/getByOrder"](this.order.id);
    },
    deliverySlots() {
      return this.$anm22.food_getDeliverySlots({
        vue: this,
        license: this.license,
        timezone: this.timezone,
        isCustomer: false,
      });
    },
  },
  methods: {
    saveNotes() {
      this.order.notes = this.$refs["fc-notes"].value;
      this.showNotesModal = false;
    },
    openCart() {
      this.cartOpen = true;
    },
    closeCart() {
      this.cartOpen = false;
    },
    /* Keypad Management ------------------------------------------------------------------------ */
    keyPressed(value) {
      if (!this.pauseKeyboardListener) {
        const permitted = /^(?=.{1}$)(\d|\.|x|-)$/i;
        if (value instanceof Event) {
          value = value.key;
        }
        // Controllo se il tasto premuto è uno di quelli permessi per la scrittura
        if (permitted.test(value) || value == "Enter" || value == "Backspace") {
          switch (value) {
            case "Enter":
              if (this.inputSelected) {
                this.endInputEdit();
              }
              break;
            case "Backspace":
              if (this.inputSelected) {
                this.inputSelected.value = this.inputSelected.value.slice(
                  0,
                  -1
                );
                return;
              } else {
                this.codeString = this.codeString.slice(0, -1);
              }
              break;
            default:
              if (this.inputSelected) {
                let oldString = this.inputSelected.value;
                //Inoltrare il tasto (solo se è un numero o il punto) all'elemento selezionato
                if (document.getSelection().toString().replace(",", ".") == oldString) {
                  oldString = "";
                }
                this.inputSelected.value = oldString.concat(value);
              } else {
                this.codeString += value;
              }
          }
        }
      }
    },
    evalString() {
      let result = {};
      for (let i = 0; i < this.cmds.length; i++) {
        const cmd = this.cmds[i];
        if (cmd.regex.test(this.codeString)) {
          result = cmd.fn(this.codeString);
          break;
        }
      }
      this.codeString = "";
      return result;
    },
    selectInput(e, callback, data) {
      if (this.inputSelected) {
        this.endInputEdit();
      }
      this.inputSelected = e.target;
      this.inputCallback = callback;
      this.inputAdditionalData = data;
      e.target.select();
      document.addEventListener("click", this.checkClickOutsideInput);
      setTimeout(function() {
        e.target.setSelectionRange(0, 9999);
      }, 1);
    },
    endInputEdit() {
      if (this.inputSelected) {
        if (this.inputCallback) {
          this[this.inputCallback](Number(this.inputSelected.value));
        } else {
          //Simulo onchange sull'input
          if ("createEvent" in document) {
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent("change", false, true);
            this.inputSelected.dispatchEvent(evt);
          } else {
            this.inputSelected.fireEvent("onchange");
          }
        }
        this.inputSelected.blur();
        this.inputSelected = this.inputCallback = this.inputAdditionalData = null;
        document.removeEventListener("click", this.checkClickOutsideInput);
      }
    },
    checkClickOutsideInput(e) {
      if (e.target !== this.inputSelected) {
        this.endInputEdit();
      }
    },
    /* Keypad Management ------------------------------------------------------------------------ */
    checkProducts() {
      clearTimeout(this.productTimer);
      this.productTimer = setTimeout(() => {
        this.$http
          .post("fast-cash/check-products", {
            elements: this.toPay,
          })
          .then((response) => {
            response.forEach((item) => {
              // Aggiorno il prodotto
              const product = this.products.find((p) => p.id === item.idProd);
              if (product) {
                product.quantity = item.qnt;
                this.$store.dispatch("foodProducts/update", {
                  vlf: this.$vlf("foodProducts"),
                  objs: [product],
                });
                if (item.over) {
                  this.$anm22.eventBus.$emit("world-headbar-show-message", {
                    text: this.$anm22.strLang(
                      this.lang,
                      "Only " +
                        product.quantity +
                        (product.stockType === 2
                          ? " units of "
                          : " " +
                            this.$anm22.tableClasses
                              .foodUnitOfMeasurement()
                              .getById(product.uom)[this.lang] +
                            "s of ") +
                        product.name +
                        " in stock",
                      "Solo " +
                        product.quantity +
                        (product.stockType === 2
                          ? " unità di "
                          : " " +
                            this.$anm22.tableClasses
                              .foodUnitOfMeasurement()
                              .getById(product.uom)[this.lang] +
                            "s di ") +
                        product.name +
                        " in magazzino"
                    ),
                    type: "alarm",
                  });
                }
              }
            });
          })
          .catch((error) => {});
      }, 500);
    },
    emptyCart() {
      this.elements = this.elements.filter((e) => e.payment);
      this.checkSequences();
    },
    newSequence() {
      if (this.toPay.filter((elem) => elem.sequence == this.order.maxSequence).length === 0) {
        return;
      }
      this.sequence = ++this.order.maxSequence;
    },
    selectSequence(sequence) {
      this.checkSequences();
      this.sequence = sequence;
    },
    checkSequences() {
      for (let s = this.order.maxSequence; s >= 1; s--) {
        let elems = this.toPay.filter((elem) => elem.sequence == s);
        if (
          elems.length === 0 &&
          s === this.order.maxSequence &&
          s > this.order.printedSequence &&
          s > 1
        ) {
          //questa sequenza deve essere eliminata
          if (this.sequence === s) {
            this.sequence--;
          }
          this.order.maxSequence--;
        }
      }
    },
    nextSequence() {
      this.save(async () => {
        try {
          const response = await this.$http.post("fast-cash/next-sequence", {
            orderId: this.order.id,
          });
          this.$store.dispatch("foodOrders/update", {
            vlf: this.$vlf("foodOrders"),
            objs: response.data.orders,
          });
        } catch (e) {
          await this.$anm22.nextSequence({
            vue: this,
            order: this.order,
            elements: this.elements,
          });
        } finally {
          this.order = this.$store.getters["foodOrders/get"](this.order.id);
          this.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: this.$anm22.strLang(
              this.lang,
              "Preparing next course",
              "Sequenza successiva in marcia"
            ),
            type: "confirm",
          });
          this.updating = false;
        }
      });
    },
    addElement(product) {
      // Check cmd string
      const cmds = this.evalString();
      let qnt = cmds.qnt ? cmds.qnt : 1;
      while (qnt > 0) {
        const localId = this.$anm22.genLocalId();
        const weight = product.pricingType === 2 ? product.defaultQuantity : "";
        const price = cmds.price
          ? cmds.price
          : product.pricingType === 2
          ? product.price * weight
          : product.price;
        this.elements.push({
          id: localId,
          dbKey: localId,
          order: this.order.id,
          product: product.id,
          productName: product.langName,
          productUnitPrice: product.price,
          productVat: product.vat,
          productUom: product.uom,
          variations: [],
          weight: weight,
          price: price,
          payment: "",
          toInsert: true,
          sequence: this.sequence,
          notes: "",
        });
        qnt--;
      }
      if (product.stockType !== 1) {
        this.checkProducts();
      }
    },
    deleteArticle(id) {
      const index = this.elements.findIndex((e) => e.id === id);
      if (-1 !== index) {
        const element = this.elements.splice(index, 1)[0];
        this.checkSequences();
        const product = this.products.find((p) => p.id === element.product);
        if (product && product.stockType !== 1) {
          this.checkProducts();
        }
      }
    },
    async updateCoversModalData(value) {
      this.showCoverModal = false;
      this.order.tableAlias = value.tableAlias;
      //Recupero il prezzo offline
      this.$set(this.order.covers, 0, value.covers);
      const now = this.$moment.tz(this.timezone);
      const switchTime = this.$moment.tz(
        this.license.coverSwitch,
        "HH:mm",
        this.timezone
      );
      const coverPrice = now.isBefore(switchTime, "hour minute second")
        ? this.license.lunchCover
        : this.license.dinnerCover;
      this.$set(this.order.covers, 1, coverPrice);
      // Aggiornamento contatto
      if (value.contact) {
        const response = await this.$http.post("contact/update-contact", {
          contact: value.contact,
        });
        if (response.data.error) {
          this.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: this.$anm22.strLang(
              this.lang,
              "Error saving contact info",
              "Errore al salvataggio del contatto"
            ),
            type: "alarm",
          });
          console.log(response.data.error);
          return;
        }
        this.contact = response.data.contact;
        this.order.contactId = response.data.contact.idContactsContact;
      }
    },
    selectContact(contact) {
      // Update order with contact id
      this.contact = contact;
      this.order.contactId = contact.idContactsContact;
    },
    resetContact() {
      this.contact = null;
      this.order.contactId = '';
    },
    changeRowWeight(value) {
      if (value < 0) {
        value = 0;
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Articles cannot have a negative weight",
            "Gli articoli non possono avere peso negativo"
          ),
          type: "warning",
        });
      }
      const elem = this.elements.find(
        (e) => e.id === this.inputAdditionalData.id
      );
      const product = this.products.find((p) => p.id === elem.product);
      if (product.stockType !== 1 && product.quantity < value) {
        value = product.quantity;
      }
      elem.weight = this.$anm22.round(value, 2);
      elem.price = this.$anm22.round(elem.productUnitPrice * elem.weight, 2);
    },
    changeRowPrice(value) {
      if (value < 0) {
        value = 0;
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Articles cannot have a negative price",
            "Gli articoli non possono avere prezzo negativo"
          ),
          type: "warning",
        });
      }
      const process = () => {
        const elem = this.elements.find(
          (e) => e.id === this.inputAdditionalData.id
        );
        const price = value;
        if (!elem.weight && elem.variations.length === 0) {
          let toChange = this.toPay.filter(
            (e) => e.product === elem.product && e.sequence === elem.sequence
          );
          const newPrice = this.$anm22.round(price / toChange.length, 2);
          toChange.forEach((e, i) => {
            e.price = newPrice;
            if (i === toChange.length - 1) {
              e.price -= newPrice * toChange.length - price;
            }
          });
        } else {
          elem.price = price;
        }
      };
      this.checkAuth("productDiscount", process);
    },
    changeVarPrice(value) {
      if (value < 0) {
        value = 0;
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Articles cannot have a negative price",
            "Gli articoli non possono avere prezzo negativo"
          ),
          type: "warning",
        });
      }
      const process = () => {
        const elem = this.elements.find(
          (e) => e.id === this.inputAdditionalData.id
        );
        const varIndex = this.inputAdditionalData.index;
        elem.variations[varIndex].price = value;
      };
      this.checkAuth("productDiscount", process);
    },
    prtButton() {
      this.endInputEdit();
      if (this.sepBillMode) {
        this.sepBillAction = "prt";
        this.$nextTick(() => (this.sepBillAction = ""));
        return;
      }
      this.showPrtModal = true;
    },
    fisButton() {
      this.endInputEdit();
      if (this.sepBillMode) {
        this.sepBillAction = "fis";
        this.$nextTick(() => (this.sepBillAction = ""));
        return;
      }
      if (this.accessControl.payOrder) {
        const fis = this.printers.filter((p) => p.printMode.fis);
        if (fis.length > 1) {
          this.showFisPrintModal = true;
        } else {
          this.print(fis[0].idPrinter, "fis");
        }
      }
    },
    openVarModal(elem) {
      if (elem) {
        this.varModalElement = elem;
        this.showVarModal = true;
      }
    },
    setVariations(vars) {
      this.showVarModal = false;
      const element = this.elements.find(
        (e) => e.id === this.varModalElement.id
      );
      if (-1 !== element) {
        element.variations = vars;
      }
      this.varModalElement = null;
    },
    getDeliveryIconStyle(dt) {
      switch (dt.typeClass) {
        case 1:
        case 4:
          return { width: "45px" };
        case 3:
          return { width: "35px" };
        case 2:
        case 8:
        case 9:
        case 10:
          return { width: "40px" };
        default:
          return { width: "50px" };
      }
    },
    openDeliveryModal() {
      this.deliveryTempSelect = this.order.deliveryType;
      if (this.order.deliveryType == 1 || this.order.deliveryType == 2) {
        this.ybModalDeliveryType = this.order.deliveryType;
        if (this.order.beach) {
          this.ybSelectRef = this.order.beach;
        }
      }
      this.showDeliveryModal = true;
    },
    closeDeliveryModal() {
      this.deliveryTempSelect = null;
      this.showDeliveryModal = false;
    },
    openPaymentModal() {
      this.paymentTempSelect = this.order.paymentMethod;
      if (this.order.paymentMethod == 7 && this.order.paymentData) {
        this.ybSelectRef = this.order.paymentData.beachId;
      }
      this.showPaymentModal = true;
    },
    closePaymentModal() {
      this.paymentTempSelect = null;
      this.showPaymentModal = false;
    },
    /* Payment with Anm22 Pay */
    async searchPayCards() {
      this.loadingPayHints = true;
      try {
        const response = await this.$http.get("fast-cash/search-pay-cards", {
          params: {
            n: this.payInputName,
            e: this.payInputEmail,
            num: this.payInputNumber
          },
        });
        if (!response.data.error) {
          this.payHints = response.data.hints
            .map((card) => {
              card.isExpired = false;
              if (card.expirationDate) {
                const expiration = this.$moment
                  .tz(card.expirationDate, "X", this.timezone)
                  .endOf("day");
                const now = this.$moment.tz(this.timezone);
                if (now.isAfter(expiration)) {
                  card.isExpired = true;
                }
              }
              card.selected = false;
              if (
                this.order.paymentMethod === 9 &&
                this.order.paymentData.cardId == card.idWorldCard
              ) {
                card.selected = true;
              }
              return card;
            })
            .sort((a, b) => b.number - a.number);
          this.loadingPayHints = false;
        } else {
          throw new Error(response.data.error);
        }
      } catch (e) {
        console.log(e);
      }
    },
    setPayPayment(card) {
      this.selectedCard = card;
      this.order.paymentMethod = 9;
      this.order.paymentData = {
        cardId: card.idWorldCard,
      };
      this.payHints.find(
        (c) => c.idWorldCard === card.idWorldCard
      ).selected = true;
      this.showPaymentModal = false;
    },
    /* ---------------------- */
    setYbPayment(data) {
      this.order.paymentMethod = 7;
      this.order.paymentData = {
        beachId: data.beachId,
        beachLicense: data.beachLicense,
        umbrella: data.umbrella,
        registration: data.registration,
        signature: ''
      };
      //Popup di pagamento immediato
      this.showYbInstantModal = true;
    },
    setYbDelivery(data) {
      this.order.deliveryPrice = this.deliveryPrices[this.ybModalDeliveryType];
      this.order.deliveryType = this.ybModalDeliveryType;
      this.order.beach = data.beachId;
      this.order.beachUmbrella = data.umbrella;
      this.order.tableRef = "";
      this.order.pickUpPoint = "";
      this.order.deliveryData = { country: "it" };
      this.ybModalDeliveryType = null;
    },
    getPmStyle(pm) {
      switch (pm.typeClassLiteral) {
        case "pay":
          return { width: "40px" };
        case "ybAccount":
          return { width: "37px" };
        case "transfer":
          return { width: "38px" };
        case "satispay":
          return { width: "70px", maxWidth: "70px" };
        default:
          return {};
      }
    },
    setPaymentMethod(pm) {
      this.paymentTempSelect = pm.typeClass;
      if (pm.typeClass == 7) {
        if (this.order.paymentData.beachId) {
          this.ybSelectRef = this.order.paymentData.beachId;
        }
      } else {
        this.order.paymentMethod = pm.typeClass;
        this.order.paymentData = {};
      }
    },
    setDeliveryType(dt) {
      this.deliveryTempSelect = dt.typeClass;
      if (dt.typeClass == 1 || dt.typeClass == 2) {
        this.ybModalDeliveryType = dt.typeClass;
        if (this.order.beach) {
          this.ybSelectRef = this.order.beach;
        }
      } else if (dt.typeClass == 5) {
      } else if (dt.typeClass == 9) {
      } else {
        this.order.deliveryType = dt.typeClass;
        this.order.deliveryPrice = this.deliveryPrices[dt.typeClass];
        this.order.tableRef = "";
        this.order.beach = "";
        this.order.beachUmbrella = "";
        this.order.pickUpPoint = "";
        // reset deliveryData
        this.order.deliveryData = { country: "it" };
      }
    },
    setTable(table) {
      this.showTableModal = false;
      this.order.tableRef = table.id;
      this.order.pickUpPoint = "";
      this.order.beach = "";
      this.order.beachUmbrella = "";
      this.order.deliveryData = { country: "it" };
      this.order.deliveryType = 5;
      this.order.deliveryPrice = this.deliveryPrices[5];
      this.order.deliveryTime = "";
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
    setPickUpPointDelivery(point) {
      this.order.pickUpPoint = point;
      this.order.tableRef = "";
      this.order.beach = "";
      this.order.beachUmbrella = "";
      this.order.deliveryData = { country: "it" };
      this.order.deliveryType = 9;
      this.order.deliveryPrice = this.deliveryPrices[9];
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
    setDiscount(discount) {
      this.checkAuth("orderDiscount", () => {
        this.order.discount = Number(discount);
        if (this.order.discount > 100) {
          this.order.discount = 100;
        } else if (this.order.discount < 0) {
          this.order.discount = 0;
        }
      });
    },
    setCustomToPay(newTotal) {
      if (newTotal < 0) {
        newTotal = 0;
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Negative price forbidden",
            "Prezzo negativo non consentito"
          ),
          type: "warning",
        });
      }
      this.checkAuth("orderDiscount", () => {
        this.order.discount = this.totalArticles
          ? 100 - (newTotal * 100) / this.totalArticles
          : 0;
      });
    },
    save(callback) {
      this.checkSequences();
      if (this.elements.length > 0) {
        if (!this.order.paymentMethod) {
          this.order.paymentMethod = 1;
        }
        if (!this.order.deliveryType) {
          this.order.deliveryType = 4;
        }
        if (this.order.deliveryType !== 5 && !this.order.deliveryTime) {
          const temp = this.$moment.tz(this.timezone);
          this.order.deliveryTime = temp
            .subtract(temp.minute() % 15, "minutes")
            .seconds(0)
            .unix();
        }
        this.checkAuth("", () => {
          this.updating = true;
          let data = {};
          this.$http
            .post("fast-cash/save", {
              pin: this.pin,
              order: this.order,
              elements: this.elements,
            })
            .then((response) => {
              if (!response.data.error) {
                const orderId = this.order.id;
                Promise.all([
                  this.$store.dispatch("foodOrders/update", {
                    vlf: this.$vlf("foodOrders"),
                    objs: response.data.orders,
                  }),
                  this.$store.dispatch("foodOrderElements/update", {
                    vlf: this.$vlf("foodOrderElements"),
                    objs: response.data.orderElements,
                    // Per pulire elementi cancellati dal db
                    cleanFilters: [(e) => e.order === orderId],
                  }),
                  this.$store.dispatch("foodProducts/update", {
                    vlf: this.$vlf("foodProducts"),
                    objs: response.data.products,
                  }),
                ]).then(() => {
                  this.afterSave(
                    response.data.orders[0].id,
                    callback,
                    response.data.updatedIds
                  );
                });
              } else {
                this.updating = false;
                this.$anm22.eventBus.$emit("world-headbar-show-message", {
                  text: response.data.error,
                  type: "alarm",
                });
              }
            })
            .catch((error) => {
              //Salvataggio offline dell'ordine
              this.$anm22
                .save({
                  vue: this,
                  license: this.license,
                  timezone: this.timezone,
                  order: this.order,
                  elements: this.elements,
                  pin: this.pin,
                })
                .then((orderId) => {
                  this.afterSave(orderId, callback);
                });
            });
        });
      } else {
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "No elements in the cart!",
            "Nessun elemento nel carrello!"
          ),
          type: "alarm",
        });
      }
    },
    afterSave(orderId, callback, newIds) {
      this.order = this.$store.getters["foodOrders/get"](orderId);
      this.elements = this.$store.getters["foodOrderElements/getByOrder"](
        this.order.id
      );
      this.saved = true;
      /* Aggiorno l'url nella barra degli indirizzi */
      this.$route.params.id
        ? this.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: this.$anm22.strLang(
              this.lang,
              "Order correctly edited!",
              "Ordine correttamente modificato"
            ),
            type: "confirm",
          })
        : this.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: this.$anm22.strLang(
              this.lang,
              "Order registered!",
              "Ordine registrato!"
            ),
            type: "confirm",
          });
      if (this.$route.path !== "/fastCash/" + orderId) {
        this.$router
          .replace("/fastCash/" + orderId)
          .catch((e) => console.log(e));
        this.$Progress.finish();
      }
      if (typeof callback === "function") {
        if (newIds) {
          callback(newIds);
        } else {
          callback();
        }
      } else {
        this.pin = "";
        this.updating = false;
      }
    },
    pay(paymentData, callback) {
      let data = {};
      // Creazione id locale pagamento
      const localId = this.$anm22.genLocalId();
      // Invio al server
      this.$http
        .post("fast-cash/pay", {
          pin: this.pin,
          orderId: this.order.id,
          paymentId: localId,
          ...paymentData,
        })
        .then((response) => {
          Promise.all([
            this.$store.dispatch("foodOrders/update", {
              vlf: this.$vlf("foodOrders"),
              objs: response.data.orders,
            }),
            this.$store.dispatch("foodOrderElements/update", {
              vlf: this.$vlf("foodOrderElements"),
              objs: response.data.orderElements,
            }),
            this.$store.dispatch("foodPayments/update", {
              vlf: this.$vlf("foodPayments"),
              objs: response.data.payments,
            }),
          ]).then(() => {
            this.afterPay(response.data.payments[0].id, callback);
          });
        })
        .catch((error) => {
          //Salvataggio offline dell'ordine
          this.$anm22
            .pay({
              vue: this,
              license: this.license,
              pin: this.pin,
              order: this.order,
              paymentId: localId,
              paymentData,
            })
            .then((paymentId) => {
              this.afterPay(paymentId, callback);
            });
        });
    },
    afterPay(paymentId, callback) {
      // refresh
      this.order = this.$store.getters["foodOrders/get"](this.order.id);
      this.elements = this.$store.getters["foodOrderElements/getByOrder"](
        this.order.id
      );
      this.$anm22.eventBus.$emit("world-headbar-show-message", {
        text: this.$anm22.strLang(
          this.lang,
          "Payment successful!",
          "Pagamento avvenuto con successo!"
        ),
        type: "confirm",
      });
      if (typeof callback === "function") {
        callback(paymentId);
      } else {
        if (this.order.payed) {
          this.$router.push("/fastCash").catch((e) => console.log(e));
        }
        this.pin = "";
        this.updating = false;
      }
    },
    payOrder(receiptType, callback) {
      const paymentData = {
        elementIds: this.toPay.map((e) => e.id),
        payedTotal: this.totalToPay,
        delivery: !this.ignoreDeliveryPrice,
        covers: this.order.covers[0].filter((c) => !c).length,
        receiptType: receiptType,
      };
      if (!this.order.payed) {
        this.showPrtModal = false;
        // Ask for YB signature
        if(this.order.paymentMethod == 7 && this.license.askYbSignature && !this.order.paymentData.signature) {
          this.showYbSignModal = true;
          return;
        } 
        this.checkAuth("payOrder", () => {
          this.save((updatedIds) => {
            //Aggiorno gli id con quelli aggiornati
            if(updatedIds) {
              paymentData.elementIds.forEach((id, index) => {
                if (-1 !== Object.keys(updatedIds).indexOf(String(id))) {
                  paymentData.elementIds[index] = updatedIds[id];
                }
              });
            }
            // ------------------- SPIAGGE.IT ----------------------------------
            if (this.order.paymentMethod == "7") {
              this.$http
                .post("fast-cash/send-to-yb", {
                  orderId: this.order.id,
                  ...paymentData,
                })
                .then((response) => {
                  if (response.data.error) {
                    throw new Error(response.data.error);
                  } else {
                    this.pay(paymentData, callback);
                  }
                })
                .catch((error) => {
                  this.$anm22.eventBus.$emit("world-headbar-show-message", {
                    text: this.$anm22.strLang(
                      this.lang,
                      "Spiagge.it communication error",
                      "Errore nella comunicazione con Spiagge.it"
                    ),
                    type: "alarm",
                  });
                  this.pin = "";
                  this.updating = false;
                });
            // ------------------- TESSERA PAY --------------------------------
            } else if (this.order.paymentMethod === 9) {
              this.$http
                .post("fast-cash/send-to-pay", {
                  orderId: this.order.id,
                  ...paymentData,
                })
                .then((response) => {
                  if (response.data.error) {
                    throw new Error(response.data.error);
                  } else {
                    this.pay(paymentData, callback);
                  }
                })
                .catch((error) => {
                  let msg = "";
                  switch (error.message) {
                    case "s_card_balance":
                      msg = this.$anm22.strLang(
                        this.lang,
                        "Insufficient card balance",
                        "Credito tessera insufficiente"
                      );
                      break;
                    default:
                      msg = this.$anm22.strLang(
                        this.lang,
                        "Card payment error. Retry.",
                        "Errore nel pagamento con tessera. Riprovare."
                      );
                  }
                  this.$anm22.eventBus.$emit("world-headbar-show-message", {
                    text: msg,
                    type: "alarm",
                  });
                  this.pin = "";
                  this.updating = false;
                });
            } else {
              this.pay(paymentData, callback);
            }
          });
        });
      } else {
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Order already payed",
            "Ordine già pagato"
          ),
          type: "alarm",
        });
      }
    },
    payOrderWithYB() {
      this.payOrder("noPrint");
      this.showYbInstantModal = false;
    },
    async saveYbSignature(dataUrl) {
      this.updating = true;
      try {
        const response = await this.$http.post('fast-cash/save-yb-signature', {
          signature: dataUrl
        });
        if(response.data.error) {
          throw new Error(reponse.data.error);
        }
        this.order.paymentData['signature'] = response.data.signature;
        this.payOrderWithYB();
        this.showYbSignModal = false;
      } catch(e) {
        this.updating = false;
        console.log(e);
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Error processing signature",
            "C'è stato un errore"
          ),
          type: "alarm",
        });
      }
    },
    // GESTIONE CONTO SEPARATO -----------------------------------------------------------------------
    closeSepBill(paymentId) {
      this.sepBillMode = null;
      this.sepBillData = null;
      this.sepBillAction = "";
    },
    /* Uso i dati temporanei emessi alla chiusura del modal del conto separato */
    paySepBill(receiptType, sepBillData, callback) {
      this.checkAuth("payOrder", () => {
        this.save((updatedIds) => {
          //Aggiorno gli id con quelli aggiornati
          sepBillData.elementIds.forEach((id, index) => {
            if (-1 !== Object.keys(updatedIds).indexOf(String(id))) {
              sepBillData.elementIds[index] = updatedIds[id];
            }
          });
          const paymentData = {
            elementIds: sepBillData.elementIds,
            payedTotal: sepBillData.payedTotal,
            delivery: sepBillData.delivery,
            covers: sepBillData.covers,
            receiptType: receiptType,
          };
          if (this.order.paymentMethod === 7) {
            //Ajax metodo per l'invio a YB
            this.$http
              .post("fast-cash/send-to-yb", {
                orderId: this.order.id,
                ...paymentData,
              })
              .then((response) => {
                this.pay(paymentData, (paymentId) => {
                  this.closeSepBill();
                  if (typeof callback === "function") {
                    callback(paymentId);
                  } else {
                    this.pin = "";
                    this.updating = false;
                  }
                });
              })
              .catch((error) => {
                this.$anm22.eventBus.$emit("world-headbar-show-message", {
                  text: this.$anm22.strLang(
                    this.lang,
                    "Spiagge.it communication error",
                    "Errore nella comunicazione con Spiagge.it"
                  ),
                  type: "alarm",
                });
              });
          } else if (this.order.paymentMethod === 9) {
            /* Pagamento mediante tessera Pay */
            this.$http
              .post("fast-cash/send-to-pay", {
                orderId: this.order.id,
                ...paymentData,
              })
              .then((response) => {
                if (response.data.error) {
                  throw new Error(response.data.error);
                } else {
                  this.pay(paymentData, (paymentId) => {
                    this.closeSepBill();
                    if (typeof callback === "function") {
                      callback(paymentId);
                    } else {
                      this.pin = "";
                      this.updating = false;
                    }
                  });
                }
              })
              .catch((error) => {
                let msg = "";
                switch (error) {
                  case "s_card_balance":
                    msg = this.$anm22.strLang(
                      this.lang,
                      "Insufficient card balance",
                      "Credito tessera insufficiente"
                    );
                    break;
                  default:
                    msg = this.$anm22.strLang(
                      this.lang,
                      "Card payment error. Retry.",
                      "Errore nel pagamento con tessera. Riprovare."
                    );
                }
                this.$anm22.eventBus.$emit("world-headbar-show-message", {
                  text: msg,
                  type: "alarm",
                });
              });
          } else {
            this.pay(paymentData, (paymentId) => {
              this.closeSepBill();
              if (typeof callback === "function") {
                callback(paymentId);
              } else {
                this.pin = "";
                this.updating = false;
              }
            });
          }
        });
      });
    },
    printSep(data) {
      data = {idPrinter: data.idPrinter, mode: data.mode, sepBillData: data.sepBillData};
      if (data.mode === "fis") {
        if (this.order.payed && this.order.receiptType) {
          return;
        }
        // Se non ho ancora mostrato il popup del codice lotteria e il totale da pagare è più di un euro
        if ((this.order.paymentMethod == 2 || this.order.paymentMethod == 3) && data.sepBillData.payedTotal >= 1 && this.showLotteryModal == false) {
          this.lotteryData.function = "printSep";
          this.lotteryData.functionArgs = Array.from(arguments);
          this.showLotteryModal = true;
          return;
        }
        if(!this.order.payed && this.order.paymentMethod == 9) {
          const newBalance = this.selectedCard.balance + this.selectedCard.overdraftLimit - this.$anm22.round(data.sepBillData.totalPayed / this.selectedCard.exchangeRate, 2);
          if(newBalance < 0) {
            this.$anm22.eventBus.$emit("world-headbar-show-message", {
              text: this.$anm22.strLang(
                this.lang,
                "Insufficient card balance",
                "Credito tessera insufficiente"
              ),
              type: "alarm",
            });
            return;
          }
        }
      }
      this.checkAuth("payOrder", () => {
        const pid = data.idPrinter;
        const mode = data.mode;
        const sepBillData = data.sepBillData;
        var covers = [];
        var deliveryPrice = 0;
        if (sepBillData.covers > 0) {
          covers = [sepBillData.covers, this.order.covers[1]];
        }
        // Se pagato da cliente (receipt non settato) oppure ancora non pagato in uno degli scontrini
        if (
          (!this.order.deliveryPayment || !this.order.receiptType) &&
          sepBillData.delivery
        ) {
          deliveryPrice = this.order.deliveryPrice;
        }
        let notes = this.order.notes;
        // Dati tessera in caso di pagamento con tessera
        if(this.order.paymentMethod === 9) {
          notes += '\n' + this.selectedCard.firstName + ' ' + this.selectedCard.lastName;
          const newBalance = this.selectedCard.balance - this.$anm22.round(sepBillData.totalPayed / this.selectedCard.exchangeRate, 2);
          notes += '\n' + this.$anm22.strLang(this.lang, 'Balance: ', 'Credito residuo: ') + newBalance.toFixed(2);
        }
        if (this.order.tableRef) {
          const table = this.tables.find((t) => t.id === this.order.tableRef);
          notes += "\n" + table.name;
        }
        if (this.order.deliveryType === 7 && this.order.deliveryData) {
          notes += "\n";
          notes +=
            this.$anm22.strLang(
              this.lang,
              "Delivery to: ",
              "Consegna presso: "
            ) + "\n";
          notes += this.order.deliveryData.name + "\n";
          notes +=
            this.order.deliveryData.street +
            " " +
            this.order.deliveryData.number +
            "\n";
          if (this.order.deliveryData.line2) {
            notes += this.order.deliveryData.line2 + "\n";
          }
          notes +=
            this.order.deliveryData.zip +
            " " +
            this.order.deliveryData.city +
            " " +
            this.order.deliveryData.state +
            "\n";
          notes +=
            this.$anm22.tableClasses
              .worldCountry()
              .getById(this.order.deliveryData.country)[this.lang] + "\n";
          notes += this.order.deliveryData.phone + "\n";
          notes += this.order.deliveryData.notes;
        }
        if (this.order.deliveryType === 9 && this.order.pickUpPoint) {
          notes += "\n";
          notes +=
            this.$anm22.strLang(
              this.lang,
              "Pick-up point: ",
              "Punto di ritiro: "
            ) + "\n";
          notes += this.order.pickUpPoint[this.lang] + "\n";
        }
        if (this.order.deliveryType === 10 && this.order.deliveryData) {
          notes += "\n";
          notes +=
            this.$anm22.strLang(this.lang, "Bungalow: ", "Bungalow: ") + "\n";
          notes += this.order.deliveryData.name + "\n";
          notes +=
            this.order.deliveryData.street +
            " " +
            this.order.deliveryData.number +
            "\n";
          notes += this.order.deliveryData.phone + "\n";
          notes += this.order.deliveryData.notes;
        }
        const callbackMethod = () => {
          mode === "fis" ? this.paySepBill(1, sepBillData) : () => {};
        };
        const discount = sepBillData.listTotal - sepBillData.payedTotal;
        this.$anm22.anm22_print({
          vue: this,
          printer: pid,
          printMode: mode,
          rows: sepBillData.elementRows,
          covers,
          delivery: deliveryPrice,
          discount,
          surcharge: 0,
          paymentMethod: this.order.paymentMethod,
          notes,
          lotteryCode: this.lotteryData.lotteryCode,
          callbackMethod,
        });
      });
    },
    printSepTicket(data) {
      const pid = data.idPrinter;
      const mode = data.mode;
      const sepBillData = data.sepBillData;
      let covers = [];
      let deliveryPrice = 0;
      if (sepBillData.covers > 0) {
        covers = [sepBillData.covers, this.order.covers[1]];
      }
      // Se pagato da cliente (receipt non settato) oppure ancora non pagato in uno degli scontrini
      if (
        (!this.order.deliveryPayment || !this.order.receiptType) &&
        sepBillData.delivery
      ) {
        deliveryPrice = this.order.deliveryPrice;
      }
      let notes = this.order.notes;
      if (this.order.tableRef) {
        const table = this.tables.find((t) => t.id === this.order.tableRef);
        notes += "\n" + table.name;
      }
      if (this.order.deliveryType === 7 && this.order.deliveryData) {
        notes += "\n";
        notes +=
          this.$anm22.strLang(this.lang, "Delivery to: ", "Consegna presso: ") +
          "\n";
        notes += this.order.deliveryData.name + "\n";
        notes +=
          this.order.deliveryData.street +
          " " +
          this.order.deliveryData.number +
          "\n";
        if (this.order.deliveryData.line2) {
          notes += this.order.deliveryData.line2 + "\n";
        }
        notes +=
          this.order.deliveryData.zip +
          " " +
          this.order.deliveryData.city +
          " " +
          this.order.deliveryData.state +
          "\n";
        notes +=
          this.$anm22.tableClasses
            .worldCountry()
            .getById(this.order.deliveryData.country)[this.lang] + "\n";
        notes += this.order.deliveryData.phone + "\n";
        notes += this.order.deliveryData.notes;
      }
      if (this.order.deliveryType === 9 && this.order.pickUpPoint) {
        notes += "\n";
        notes +=
          this.$anm22.strLang(
            this.lang,
            "Pick-up point: ",
            "Punto di ritiro: "
          ) + "\n";
        notes += this.order.pickUpPoint[this.lang] + "\n";
      }
      if (this.order.deliveryType === 10 && this.order.deliveryData) {
        notes += "\n";
        notes +=
          this.$anm22.strLang(this.lang, "Bungalow: ", "Bungalow: ") + "\n";
        notes += this.order.deliveryData.name + "\n";
        notes +=
          this.order.deliveryData.street +
          " " +
          this.order.deliveryData.number +
          "\n";
        notes += this.order.deliveryData.phone + "\n";
        notes += this.order.deliveryData.notes;
      }
      // Lo sconto è calcolato in valore assoluto sulla base dei totali
      const discount = this.$anm22.round(
        sepBillData.listTotal - sepBillData.payedTotal,
        2
      );
      this.$anm22.anm22_print({
        vue: this,
        printer: pid,
        printMode: "fis",
        rows: sepBillData.elementRows,
        covers,
        delivery: deliveryPrice,
        discount,
        surcharge: 0,
        paymentMethod: 7,
        notes,
        callbackMethod: () => this.save(),
      });
    },
    printInvoiceSep(sepBillData) {
      this.paySepBill(2, sepBillData, (paymentId) => {
        this.pin = "";
        this.updating = false;
        this.invPayment = paymentId;
        this.showInvoiceModal = true;
      });
    },
    // CANCELLA ORDINE ----------------------------------------------------------------
    deleteOrder() {
      if (this.saved == true) {
        this.checkAuth("deleteOrder", () => {
          this.$http
            .post("fast-cash/delete-order", {
              orderId: this.order.id,
            })
            .then((response) => {
              this.$store
                .dispatch("foodOrders/delete", {
                  vlf: this.$vlf("foodOrders"),
                  obj: this.order,
                })
                .then(() => {
                  this.$router.push("/fastCash").catch((e) => this.loadPage());
                })
                .catch((error) => {});
            })
            .catch((error) => {
              this.$anm22
                .deleteOrder(this, {
                  license: this.license,
                  order: this.order,
                  pin: this.pin,
                })
                .then(() => {
                  this.$router.push("/fastCash").catch((e) => this.loadPage());
                });
            });
        });
      } else {
        this.loadPage();
      }
    },
    confirmLottery() {
      this.lotteryData.error = false;
      // Check lottery code format
      if (
        this.lotteryData.lotteryCode !== null &&
        (this.lotteryData.lotteryCode.length !== 8 ||
          !/^[a-zA-Z0-9]+$/.test(this.lotteryData.lotteryCode))
      ) {
        this.lotteryData.error = true;
        return;
      }
      this[this.lotteryData.function](...this.lotteryData.functionArgs);
      this.showLotteryModal = false;
      this.lotteryData = {
        lotteryCode: null,
        function: null,
        functionArgs: null,
      };
    },
    print(pid, mode) {
      if (mode === window.WorldPrintContent_PrintModes.FISCAL) {
        if (this.order.payed && this.order.receiptType) {
          return;
        }
        if (this.printing) {
          return;
        }
        // Se non ho ancora mostrato il popup del codice lotteria e il totale da pagare è più di un euro
        if ((this.order.paymentMethod == 2 || this.order.paymentMethod == 3) && this.totalToPay >= 1 && this.showLotteryModal === false) {
          this.lotteryData.function = "print";
          this.lotteryData.functionArgs = Array.from(arguments);
          this.showLotteryModal = true;
          return;
        }
        if(!this.order.payed && this.order.paymentMethod == 9) {
          const newBalance = this.selectedCard.balance + this.selectedCard.overdraftLimit - this.$anm22.round(this.totalToPay / this.selectedCard.exchangeRate, 2);
          if(newBalance < 0) {
            this.$anm22.eventBus.$emit("world-headbar-show-message", {
              text: this.$anm22.strLang(
                this.lang,
                "Insufficient card balance",
                "Credito tessera insufficiente"
              ),
              type: "alarm",
            });
            return;
          }
        }
        this.printing = true;
      }
      this.checkAuth("payOrder", () => {
        let covers = [];
        let deliveryPrice = 0;
        const coversToPay = this.order.covers[0].filter((c) => !c).length;
        if (coversToPay > 0) {
          covers = [coversToPay, this.order.covers[1]];
        }
        // Se pagato da cliente (receipt non settato) oppure ancora non pagato in uno degli scontrini
        if (
          (!this.order.deliveryPayment || !this.order.receiptType) &&
          !this.ignoreDeliveryPrice
        ) {
          deliveryPrice = this.order.deliveryPrice;
        }
        let notes = this.order.notes;
        // Dati tessera in caso di pagamento con tessera
        if(this.order.paymentMethod === 9) {
          notes += '\n' + this.selectedCard.firstName + ' ' + this.selectedCard.lastName;
          const newBalance = this.selectedCard.balance - this.$anm22.round(this.totalToPay / this.selectedCard.exchangeRate, 2);
          notes += '\n' + this.$anm22.strLang(this.lang, 'Balance: ', 'Credito residuo: ') + newBalance.toFixed(2);
        }
        // Dati tavolo se ordine al tavolo
        if (this.order.tableRef) {
          const table = this.tables.find((t) => t.id === this.order.tableRef);
          notes += "\n" + table.name;
        }
        // Dati consegna
        if (this.order.deliveryType === 7 && this.order.deliveryData) {
          notes += "\n";
          notes +=
            this.$anm22.strLang(
              this.lang,
              "Delivery to: ",
              "Consegna presso: "
            ) + "\n";
          notes += this.order.deliveryData.name + "\n";
          notes +=
            this.order.deliveryData.street +
            " " +
            this.order.deliveryData.number +
            "\n";
          if (this.order.deliveryData.line2) {
            notes += this.order.deliveryData.line2 + "\n";
          }
          notes +=
            this.order.deliveryData.zip +
            " " +
            this.order.deliveryData.city +
            " " +
            this.order.deliveryData.state +
            "\n";
          notes +=
            this.$anm22.tableClasses
              .worldCountry()
              .getById(this.order.deliveryData.country)[this.lang] + "\n";
          notes += this.order.deliveryData.phone + "\n";
          notes += this.order.deliveryData.notes ? this.order.deliveryData.notes : '';
        }
        if (this.order.deliveryType === 9 && this.order.pickUpPoint) {
          notes += "\n";
          notes +=
            this.$anm22.strLang(
              this.lang,
              "Pick-up point: ",
              "Punto di ritiro: "
            ) + "\n";
          notes += this.order.pickUpPoint[this.lang] + "\n";
        }
        if (this.order.deliveryType === 10 && this.order.deliveryData) {
          notes += "\n";
          notes +=
            this.$anm22.strLang(this.lang, "Bungalow: ", "Bungalow: ") + "\n";
          notes += this.order.deliveryData.name + "\n";
          notes +=
            this.order.deliveryData.street +
            " " +
            this.order.deliveryData.number +
            "\n";
          notes += this.order.deliveryData.phone + "\n";
          notes += this.order.deliveryData.notes;
        }
        const rows = this.order.payed
          ? this.getRowsToPrint(this.payed)
          : this.getRowsToPrint(this.toPay);
        const callbackMethod = () => {
          this.printing = false;
          if (mode === "fis") {
            if (this.order.payed) {
              this.$router.push("/fastCash").catch((e) => console.log(e));
            } else {
              this.payOrder(1);
            }
          } else {
            this.order.nonFiscalPrinted = true;
            this.save();
          }
        };
        // Lo sconto è calcolato in valore assoluto sulla base dei totali
        const discount = this.$anm22.round(
          this.totalArticles - this.totalToPay,
          2
        );
        const surcharge = this.order.surcharge
          ? this.$anm22.round(this.order.surcharge, 2)
          : 0;
        this.$anm22.anm22_print({
          vue: this,
          printer: pid,
          printMode: mode,
          rows,
          covers,
          delivery: deliveryPrice,
          discount,
          surcharge,
          paymentMethod: this.order.paymentMethod,
          notes,
          lotteryCode: this.lotteryData.lotteryCode,
          callbackMethod,
        });
      });
    },
    // printTicket(pid) {
    //   if (this.order.payed && this.order.receiptType) {
    //     return;
    //   }
    //   let covers = [];
    //   let deliveryPrice = 0;
    //   const coversToPay = this.order.covers[0].filter((c) => !c).length;
    //   if (coversToPay > 0) {
    //     covers = [coversToPay, this.order.covers[1]];
    //   }
    //   // Se pagato da cliente (receipt non settato) oppure ancora non pagato in uno degli scontrini
    //   if (
    //     (!this.order.deliveryPayment || !this.order.receiptType) &&
    //     !this.ignoreDeliveryPrice
    //   ) {
    //     deliveryPrice = this.order.deliveryPrice;
    //   }
    //   let notes = this.order.notes;
    //   if (this.order.tableRef) {
    //     const table = this.tables.find((t) => t.id === this.order.tableRef);
    //     notes += "\n" + table.name;
    //   }
    //   if (this.order.deliveryType === 7 && this.order.deliveryData) {
    //     notes += "\n";
    //     notes +=
    //       this.$anm22.strLang(this.lang, "Delivery to: ", "Consegna presso: ") +
    //       "\n";
    //     notes += this.order.deliveryData.name + "\n";
    //     notes +=
    //       this.order.deliveryData.street +
    //       " " +
    //       this.order.deliveryData.number +
    //       "\n";
    //     if (this.order.deliveryData.line2) {
    //       notes += this.order.deliveryData.line2 + "\n";
    //     }
    //     notes +=
    //       this.order.deliveryData.zip +
    //       " " +
    //       this.order.deliveryData.city +
    //       " " +
    //       this.order.deliveryData.state +
    //       "\n";
    //     notes +=
    //       this.$anm22.tableClasses
    //         .worldCountry()
    //         .getById(this.order.deliveryData.country)[this.lang] + "\n";
    //     notes += this.order.deliveryData.phone + "\n";
    //     notes += this.order.deliveryData.notes;
    //   }
    //   const rows = this.order.payed
    //     ? this.getRowsToPrint(this.payed)
    //     : this.getRowsToPrint(this.toPay);
    //   // Lo sconto è calcolato in valore assoluto sulla base dei totali
    //   const discount = this.$anm22.round(
    //     this.totalArticles - this.totalToPay + this.order.surcharge,
    //     2
    //   );
    //   const surcharge = this.$anm22.round(this.order.surcharge, 2);
    //   this.$anm22.anm22_print({
    //     vue: this,
    //     printer: pid,
    //     printMode: "fis",
    //     rows,
    //     covers,
    //     delivery: deliveryPrice,
    //     discount,
    //     surcharge,
    //     paymentMethod: 7,
    //     notes,
    //     callbackMethod: () => this.save(),
    //   });
    // },
    printRecap(pid) {
      const printFn = () => {
        const content = new WorldPrintContent();
        content.printMode = "text";

        let orderString = "";
        if (this.order.number) {
          orderString = this.order.number;
        } else {
          orderString = this.order.id;
        }

        //Text
        let body = "";
        body +=
          this.$anm22.strLang(
            this.lang,
            "Recap Order #",
            "Riepilogo Ordine #"
          ) + orderString;
        body += "\n";
        // CONSEGNA ---------------------------------------------------------------------------
        body += "\n" + this.$anm22.strLang(this.lang, "DELIVERY", "CONSEGNA");
        // Orario di consegna
        let dt_string = "";
        const dt = this.$moment.tz(this.order.deliveryTime, "X", this.timezone);
        if (dt.isSame(this.now, "day")) {
          dt_string = dt.format("LT");
        } else {
          dt_string = dt.format("L LT");
        }
        body +=
          "\n" +
          this.$anm22.strLang(this.lang, "TIME: ", "ORARIO: ") +
          dt_string;
        // Dati di consegna
        switch (Number.parseInt(this.order.deliveryType)) {
          case 1:
          case 2:
            if (this.order.beach && this.order.beachUmbrella) {
              const beach = this.$store.getters["works/get"](this.order.beach);
              body +=
                "\n" +
                this.$anm22.strLang(this.lang, "UMBRELLA ", "OMBRELLONE ") +
                this.order.beachUmbrella;
              body +=
                "\n" +
                this.$anm22.strLang(this.lang, "AT ", "PRESSO ") +
                beach.name;
            }
            break;
          case 3:
            body += "\n" + "CHIRINGUITO";
            break;
          case 4:
            body += "\n" + "BAR";
            break;
          case 5:
            if (this.order.tableRef) {
              const table = this.$store.getters["foodTables/get"](
                this.order.tableRef
              );
              body +=
                "\n" +
                this.$anm22.strLang(this.lang, "TABLE ", "TAVOLO ") +
                table.name;
              if (this.order.tableAlias) {
                body += " - " + this.order.tableAlias;
              }
            }
            break;
          case 7:
            body += "\n" + "DOMICILIO";
            body += "\n" + this.order.deliveryData.name;
            body +=
              "\n" +
              this.order.deliveryData.street +
              " " +
              this.order.deliveryData.number;
            if (this.order.deliveryData.line2) {
              body += "\n" + this.order.deliveryData.line2;
            }
            body +=
              "\n" +
              this.order.deliveryData.zip +
              " " +
              this.order.deliveryData.city +
              " " +
              this.order.deliveryData.state;
            body +=
              "\n" +
              this.$anm22.tableClasses
                .worldCountry()
                .getById(this.order.deliveryData.country)[this.lang];
            body += "\n" + this.order.deliveryData.phone;
            body += "\n" + this.order.deliveryData.notes;
            break;
          case 9:
            if (this.order.pickUpPoint) {
              body +=
                "\n" +
                this.$anm22.strLang(
                  this.lang,
                  "PICK-UP POINT",
                  "PUNTO DI RITIRO"
                );
              body += "\n" + this.order.pickUpPoint[this.lang];
            }
            break;
          case 10:
            body += "\n" + "BUNGALOW";
            body += "\n" + this.order.deliveryData.name;
            body +=
              "\n" +
              this.order.deliveryData.street +
              " " +
              this.order.deliveryData.number;
            body += "\n" + this.order.deliveryData.phone;
            body += "\n" + this.order.deliveryData.notes;
            break;
        }
        // PAGAMENTO ----------------------------------------------------------------------------
        body += "\n";
        body += "\n" + this.$anm22.strLang(this.lang, "PAYMENT", "PAGAMENTO");
        switch (Number.parseInt(this.order.paymentMethod)) {
          case 1:
            body += "\n" + this.$anm22.strLang(this.lang, "CASH", "CONTANTI");
            break;
          case 2:
            body += "\n" + "BANCOMAT";
            break;
          case 3:
            body +=
              "\n" +
              this.$anm22.strLang(this.lang, "CREDIT CARD", "CARTA DI CREDITO");
            break;
          case 7:
            body += "\n" + "SPIAGGE.IT";
            body +=
              "\n" +
              this.$anm22.strLang(this.lang, "UMBRELLA ", "OMBRELLONE ") +
              this.order.paymentData.umbrella;
            const beach = this.$store.getters["works/get"](
              this.order.paymentData.beachId
            );
            body +=
              "\n" +
              this.$anm22.strLang(this.lang, "AT ", "PRESSO ") +
              beach.name;
            break;
        }
        // Coperti ----------------------------------------------------------------------------------
        const covers = this.order.covers[0].length;
        if (covers > 0) {
          body += "\n";
          const s_covers_desc = this.$anm22.strLang(
            this.lang,
            "Covers",
            "Coperti"
          );
          const s_covers_qnt = ("x" + covers).padStart(4, " ");
          const s_covers_price =
            " EUR " + this.order.covers[1].toFixed(2).padStart(6, " ");
          body +=
            "\n" +
            s_covers_desc +
            new Array(
              45 -
                s_covers_desc.length -
                s_covers_qnt.length -
                s_covers_price.length +
                1
            ).join(" ") +
            s_covers_qnt +
            s_covers_price;
        }
        // Elementi ---------------------------------------------------------------------------------
        body += "\n";
        const rows = [];
        this.elements.forEach((e) => {
          let description = "",
            price = e.price;
          if (e.weight) {
            description =
              e.weight +
              " " +
              this.$anm22.tableClasses
                .foodUnitOfMeasurement()
                .getById(e.productUom)["typeClassLiteral"] +
              " " +
              e.productName;
            rows.push({
              elem: e,
              description,
              price,
              quantity: 1,
            });
            e.variations.forEach((v) => {
              rows.push({
                elem: null,
                description:
                  "  " +
                  v.sign +
                  " " +
                  this.$anm22.food_getVariationName(this.lang, v),
                price: v.price,
                quantity: 1,
              });
            });
          } else {
            description = e.productName;
            if (e.variations.length > 0) {
              rows.push({
                elem: e,
                description,
                price,
                quantity: 1,
              });
              e.variations.forEach((v) => {
                rows.push({
                  elem: null,
                  description:
                    "  " +
                    v.sign +
                    " " +
                    this.$anm22.food_getVariationName(this.lang, v),
                  price: v.price,
                  quantity: 1,
                });
              });
            } else {
              const found = rows.findIndex(
                (r) =>
                  r.elem &&
                  !r.elem.weight &&
                  r.elem.variations.length === 0 &&
                  r.elem.product === e.product
              );
              if (-1 !== found) {
                rows[found].quantity++;
                rows[found].price += e.price;
              } else {
                rows.push({
                  elem: e,
                  description,
                  price,
                  quantity: 1,
                });
              }
            }
          }
        });
        // Print rows
        rows.forEach((r) => {
          const s_description = r.description;
          const s_qnt = ("x" + r.quantity).padStart(4, " ");
          const s_price = " EUR " + r.price.toFixed(2).padStart(6, " ");

          if (s_description.length > 30) {
            s_description = s_description.substring(0, 30);
          }
          const spaces =
            45 - s_description.length - s_qnt.length - s_price.length;
          body +=
            "\n" +
            this.$anm22.escapeHtml(s_description) +
            new Array(spaces + 1).join(" ") +
            s_qnt +
            s_price;
        });
        // Costo di consegna
        if (this.order.deliveryPrice) {
          body += "\n";
          const s_delivery_desc = this.$anm22.strLang(
            this.lang,
            "Delivery cost",
            "Costo di consegna"
          );
          const s_delivery_price =
            " EUR " + this.order.deliveryPrice.toFixed(2).padStart(6, " ");
          body +=
            "\n" +
            s_delivery_desc +
            new Array(
              45 - s_delivery_desc.length - s_delivery_price.length + 1
            ).join(" ") +
            s_delivery_price;
        }
        // Sconto
        const discount =
          this.order.listTotal - this.totalOrder + this.order.surcharge;
        if (discount) {
          body += "\n";
          const s_discount_desc = this.$anm22.strLang(
            this.lang,
            "Discount",
            "Sconto"
          );
          const s_discount_price =
            " EUR " + discount.toFixed(2).padStart(6, " ");
          body +=
            "\n" +
            s_discount_desc +
            new Array(
              45 - s_discount_desc.length - s_discount_price.length + 1
            ).join(" ") +
            s_discount_price;
        }
        // Sovrapprezzo
        if (this.order.surcharge) {
          body += "\n";
          const s_surcharge_desc = this.$anm22.strLang(
            this.lang,
            "Service cost",
            "Costo di servizio"
          );
          const s_surcharge_price =
            " EUR " + this.order.surcharge.toFixed(2).padStart(6, " ");
          body +=
            "\n" +
            s_surcharge_desc +
            new Array(45 - s_surcharge_desc - s_surcharge_price + 1).join(" ") +
            s_surcharge_price;
        }
        // Totali -----------------------------------------------------------------------------------
        body += "\n";
        const s_total_desc = this.$anm22.strLang(this.lang, "Total", "Totale");
        const s_total_price =
          " EUR " + this.totalOrder.toFixed(2).padStart(6, " ");
        body +=
          "\n" +
          s_total_desc +
          new Array(45 - s_total_desc.length - s_total_price.length + 1).join(
            " "
          ) +
          s_total_price;
        // Note -------------------------------------------------------------------------------------
        if (this.order.notes) {
          body += "\n";
          body += "\n" + this.order.notes.match(/[^]{1,45}/g).join("\n");
        }
        // Spazio per firma -------------------------------------------------------------------------
        body += "\n\n";
        body +=
          "\n" +
          this.$anm22.strLang(this.lang, "SIGNATURE", "FIRMA").padEnd(45, "_");

        body += "\n\n";

        content.text = body;
        window["world_printer_" + pid].print(content);
      };
      this.save(() => {
        this.pin = "";
        this.updating = false;
        printFn();
      });
    },
    printInvoice() {
      if (this.canEmitInvoice) {
        this.showInvoiceModal = true;
        this.showPrtModal = false;
      } else {
        this.showInvoiceSeriesError = true;
      }
    },
    payOrderFromInvoice() {
      this.payOrder(2, (paymentId) => {
        this.pin = "";
        this.updating = false;
        this.invPayment = paymentId;
        // Modal already open
      });
    },
    closeInvoiceModal() {
      this.showInvoiceModal = false;
      this.invPayment = "";
      this.invInvoice = "";
    },
    async printKitchenTicket() {
      try {
        const response = await this.$http.post("fast-cash/print-kitchen", {
          orderId: this.order.id,
        });
        if (!response.data.error) {
          this.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: this.$anm22.strLang(
              this.lang,
              "Kitchen ticket successfully printed",
              "Comanda stampata con successo"
            ),
            type: "confirm",
          });
        } else {
          this.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: this.$anm22.strLang(
              this.lang,
              "There was an unexpected error, try again.",
              "Errore durante la stampa della comanda, riprovare."
            ),
            type: "alarm",
          });
        }
      } catch (e) {
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Go back online to print the ticket.",
            "Tornare online per stampare la comanda."
          ),
          type: "alarm",
        });
      }
    },
    getRowsToPrint(elements) {
      console.log(elements);
      const result = [];
      elements.forEach((e) => {
        if (e.weight === "") {
          if (e.variations.length === 0) {
            /* cerco se una riga con questo prodotto è già presente nell'array */
            const found = result.findIndex(
              (row) => row.elem.product == e.product
            );
            /* Se esiste aggiorno la riga altrimenti la creo e la aggiungo */
            if (-1 !== found) {
              result[found].elem = e;
              result[found].quantity++;
              result[found].price += e.price;
            } else {
              result.push({
                elem: e,
                quantity: 1,
                weight: null,
                price: e.price,
              });
            }
          } else {
            result.push({
              elem: e,
              quantity: 1,
              weight: null,
              price: e.price,
            });
          }
        } else {
          result.push({
            elem: e,
            quantity: 1,
            weight: e.weight,
            price: e.price,
          });
        }
      });
      return result;
    },
    // GESTIONE STAMPANTI --------------------------------------------------------
    printFinancialReport(idPrinter) {
      window["world_printer_" + idPrinter].execDailyReport();
      this.showManagePrintersModal = false;
    },
    printDailyClosure(idPrinter) {
      window["world_printer_" + idPrinter].execDailyClosure();
      this.showManagePrintersModal = false;
    },
    openPrintReceiptsModal(idPrinter) {
      this.selectedPrinter = idPrinter;
      this.showPrintReceiptsModal = true;
    },
    closePrintReceiptsModal() {
      this.showPrintReceiptsModal = false;
      this.selectedPrinter = null;
    },
    printReceipts() {
      const date = this.$refs["printReceiptsDate"].value;
      const dateParts = date.split("-");
      window["world_printer_" + this.selectedPrinter].printReceiptsByDate(
        dateParts[0],
        dateParts[1],
        dateParts[2]
      );
      this.closePrintReceiptsModal();
      this.showManagePrintersModal = false;
    },
    openCancelReceiptModal(idPrinter) {
      this.selectedPrinter = idPrinter;
      this.showCancelReceiptModal = true;
    },
    closeCancelReceiptModal() {
      this.showCancelReceiptModal = false;
      this.selectedPrinter = null;
    },
    cancelReceipt() {
      const code = this.$refs["cancelReceiptCode"].value;
      const date = this.$refs["cancelReceiptDate"].value;
      const dateParts = date.split("-");
      window[
        "world_printer_" + this.selectedPrinter
      ].receiptCancellationAutomatic(
        code,
        dateParts[0],
        dateParts[1],
        dateParts[2]
      );
      this.closeCancelReceiptModal();
      this.showManagePrintersModal = false;
    },
    openDrawer(pid) {
      window["world_printer_" + pid].openDrawer();
      this.showDrawersModal = false;
    },
    // ---------------------------------------------------------------------------
    installChromeExtension() {
      window.open(
        "https://chrome.google.com/webstore/detail/deoglaoecglnimkaggbbgdkmhbdfgjid",
        "_blank"
      );
    },
    checkAuth(req, callback) {
      if (this.permission == "5" && this.pin === "") {
        const requestData = {
          acRequest: req,
          success: (pin) => {
            this.pin = pin;
            callback();
          },
          error: (pin) => {
            // this.$anm22.eventBus.$emit("world-headbar-show-message", {
            //   text: this.$anm22.strLang(
            //     this.lang,
            //     "User not authorized",
            //     "Utente non autorizzato"
            //   ),
            //   type: "alarm"
            // });
          },
        };
        this.$anm22.eventBus.$emit("food-pin-authorization", requestData);
      } else {
        callback();
      }
    },
    initSecondaryData() {
      /* Init sequenze e counter id */
      if (this.order.maxSequence < this.order.printedSequence) {
        this.order.maxSequence = this.order.printedSequence;
      }
      this.sequence = this.order.maxSequence;
      this.checkSequences();
    },
    loadPrinters() {
      this.printers.forEach((p) => {
        window.createPrinter(p, process.env.VUE_APP_BACK_DOMAIN);
      });
    },
    generateOrder() {
      const localId = this.$anm22.genLocalId();
      this.order = {
        id: localId,
        dbKey: localId,
        orderDate: "",
        lastModified: "",
        license: this.license.id,
        createdBy: this.user.idWorldUser,
        customer: "",
        status: 3,
        estimatedTime: "",
        isPaying: false,
        payed: false,
        // id di pagamento valorizzato quando viene creato un pagamento che comprende il costo di consegna
        deliveryPayment: "",
        paymentMethod: 1, //contanti
        paymentData: [],
        deliveryType: 4, //ritiro bar
        beach: "",
        beachUmbrella: "",
        tableRef: "",
        tableAlias: "",
        pickUpPoint: "",
        deliveryData: {
          country: "it",
        },
        deliveryTime: "",
        deliveryPrice: this.deliveryPrices[this.deliveryTypes[0]],
        surcharge: 0,
        discount: 0,
        totalVAT: 0,
        listTotal: 0,
        toPayTotal: 0,
        payedTotal: 0,
        receiptType: "",
        notes: "",
        printedSequence: 0,
        maxSequence: 1,
        printedSequenceTime: "",
        // Array di id di pagamento (se 0 non è stato pagato) + prezzo dei coperti
        covers: [[], 0],
        // invoice: "",
      };
      this.elements = [];
    },
    async loadData() {
      await Promise.all([
        this.$store.dispatch("foodLicenses/load", this.$vlf("foodLicenses")),
        this.$store.dispatch(
          "foodEmployments/load",
          this.$vlf("foodEmployments")
        ),
        this.$store.dispatch("foodAcs/load", this.$vlf("foodAcs")),
        this.$store.dispatch(
          "foodCategories/load",
          this.$vlf("foodCategories")
        ),
        this.$store.dispatch("foodProducts/load", this.$vlf("foodProducts")),
        this.$store.dispatch("foodRooms/load", this.$vlf("foodRooms")),
        this.$store.dispatch("foodTables/load", this.$vlf("foodTables")),
        this.$store.dispatch("ybLicenses/load", this.$vlf("ybLicenses")),
        this.$store.dispatch("works/load", this.$vlf("works")),
        this.$store.dispatch("foodPrinters/load", this.$vlf("foodPrinters")),
        this.$store.dispatch("foodOrders/load", this.$vlf("foodOrders")),
        this.$store.dispatch(
          "foodOrderElements/load",
          this.$vlf("foodOrderElements")
        ),
        this.$store.dispatch("foodPayments/load", this.$vlf("foodPayments")),
      ]);
    },
    async loadPage() {
      // Recupero dati necessari
      let queryString = "";
      if (this.$route.params.id) {
        queryString += "orderId=" + this.$route.params.id;
      }
      // Online
      try {
        const response = await this.$http.get("fast-cash?" + queryString);
        await Promise.all([
          this.$store.dispatch("foodLicenses/update", {
            vlf: this.$vlf("foodLicenses"),
            objs: [response.data.license],
          }),
          this.$store.dispatch("foodEmployments/update", {
            vlf: this.$vlf("foodEmployments"),
            objs: [response.data.employment],
          }),
          this.$store.dispatch("foodAcs/update", {
            vlf: this.$vlf("foodAcs"),
            objs: [response.data.accessControl],
          }),
          this.$store.dispatch("foodCategories/update", {
            vlf: this.$vlf("foodCategories"),
            objs: response.data.categories,
            cleanFilters: [],
          }),
          this.$store.dispatch("foodProducts/update", {
            vlf: this.$vlf("foodProducts"),
            objs: response.data.products,
            cleanFilters: [],
          }),
          this.$store.dispatch("foodRooms/update", {
            vlf: this.$vlf("foodRooms"),
            objs: response.data.rooms,
          }),
          this.$store.dispatch("foodTables/update", {
            vlf: this.$vlf("foodTables"),
            objs: response.data.tables,
          }),
          this.$store.dispatch("ybLicenses/update", {
            vlf: this.$vlf("ybLicenses"),
            objs: response.data.ybLicenses,
          }),
          this.$store.dispatch("works/update", {
            vlf: this.$vlf("works"),
            objs: response.data.works,
          }),
          this.$store.dispatch("foodPrinters/update", {
            vlf: this.$vlf("foodPrinters"),
            objs: response.data.printers,
          }),
          //Ordini delle ultime 24 ore + ordine richiesto
          this.$store.dispatch("foodOrders/update", {
            vlf: this.$vlf("foodOrders"),
            objs: response.data.orders,
          }),
          //Elemento ordine richiesto
          this.$store.dispatch("foodOrderElements/update", {
            vlf: this.$vlf("foodOrderElements"),
            objs: response.data.orderElements,
            cleanFilters: [(e) => e.order == this.$route.params.id],
          }),
          this.$store.dispatch("foodPayments/update", {
            vlf: this.$vlf("foodPayments"),
            objs: response.data.payments,
            cleanFilters: [(p) => p.order === this.$route.params.id],
          }),
        ]);
        // Pay card
        if(response.data.card) {
          const card = response.data.card;
          card.isExpired = false;
          if (card.expirationDate) {
            const expiration = this.$moment
              .tz(card.expirationDate, "X", this.timezone)
              .endOf("day");
            const now = this.$moment.tz(this.timezone);
            if (now.isAfter(expiration)) {
              card.isExpired = true;
            }
          }
          card.selected = true;
          this.payHints.push(card);
          this.selectedCard = card;
        } else {
          this.payHints = [];
          this.selectedCard = null;
        }
        if (response.data.contact) {
          this.contact = response.data.contact;
        } else {
          this.contact = null;
        }
      } catch (e) {}
      if (this.$route.params.id) {
        this.order = this.$store.getters["foodOrders/get"](
          this.$route.params.id
        );
        if (this.order) {
          this.elements = this.$store.getters["foodOrderElements/getByOrder"](
            this.order.id
          );
          this.saved = true;
        } else {
          this.$router.push("/fastCash").catch((e) => console.log(e));
          return;
        }
      } else {
        this.generateOrder();
      }
      if (this.$route.query.tableId) {
        const table = this.$store.getters["foodTables/get"](
          this.$route.query.tableId
        );
        if (table) {
          this.setTable(table);
        }
      }
      if (this.$route.query.beachLicense && this.$route.query.umbrella) {
        const ybl = this.ybLicenses.find(
          (ybl) => ybl.ybLicense == this.$route.query.beachLicense
        );
        if (ybl) {
          this.order.paymentMethod = 7;
          this.order.paymentData = {
            beachId: ybl.beach,
            beachLicense: ybl.ybLicense,
            umbrella: this.$route.query.umbrella,
            registration: this.$route.query.registration,
          };
        }
      }
      this.initSecondaryData();
      this.loadPrinters();
      this.loading = false;
      this.$Progress.finish();
      document.title = this.$anm22.strLang(
        this.lang,
        "Register",
        "Cassa rapida"
      );
      this.$store.dispatch(
        "headbar/setHeadbarTitle",
        this.$anm22.strLang(this.lang, "Register", "Cassa rapida")
      );
    },
  },
  async created() {
    // License config module check
    if (!this.license.config.modules.fastCash.enabled) {
      await this.$router.push("/inventory");
      return;
    }
    // ACL check - waiter
    if (!this.accessControl.fastCash) {
      await this.$router.push("/tables");
      return;
    }
    await this.loadData();
    await this.loadPage();
  },
  mounted() {
    this.$store.dispatch("headbar/addButtons", [
      {
        mobileHide: false,
        img: this.$anm22.icons.getWorldIcon("add"),
        offlineImg: this.$anm22.icons.getWorldIcon("add"),
        title: this.$anm22.strLang(this.lang, "New order", "Nuovo ordine"),
        clickFn: () => {
          if (this.$route.params.id) {
            this.$router.push("/fastCash").catch((e) => console.log(e));
          } else {
            this.loadPage();
          }
        },
      },
      {
        mobileHide: true,
        img: this.$anm22.icons.getWorldIcon("drawer"),
        offlineImg: this.$anm22.icons.getWorldIcon("drawer"),
        title: this.$anm22.strLang(
          this.lang,
          "Open printer drawer",
          "Apri cassetto stampante"
        ),
        style: {
          width: "30px",
          height: "30px",
          margin: "10px",
        },
        clickFn: () => {
          // Only EPSON FP81 is enabled at the moment
          const printerIds = this.printers
            .filter((p) => p.printMode.fis && p.model == 21)
            .map((p) => p.idPrinter);
          if (printerIds.length === 1) {
            window["world_printer_" + printerIds[0]].openDrawer();
          } else {
            // open popup
            this.showDrawersModal = true;
          }
        },
      },
    ]);
    // Listen for keyboard events to write in codeString
    window.addEventListener("keyup", this.keyPressed);
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.keyPressed);
    this.$store.dispatch("headbar/removeButtons");
  },
  watch: {
    $route(to, from) {
      if(from.params.id && !to.params.id) {
        this.loadPage();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fc-cp-select {
  &.disabled {
    opacity: 0.3;
    pointer-events: null;
  }
}
.fc-sp-div {
  background-color: #fff;
  padding: 0;
}
.code-string-div {
  height: 40px;
  padding: 10px;
  font-size: 20px;
  flex-wrap: nowrap;
  align-items: center;
  background-color: #efefef;
}
.input-div {
  cursor: pointer;
  border-radius: 4px;
  padding: 5px;
  min-height: 36px;
  flex-wrap: nowrap;
  align-items: center;
  &:hover {
    background-color: #eee;
  }
  &.active {
    border: 1px solid #2196f3;
  }
}
.action-btn {
  border-radius: 5px;
  background-color: #eee;
  padding: 10px;
  cursor: pointer;
  height: 50px;
  flex-wrap: nowrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
  &:hover {
    box-shadow: 0 0 0 2px #2196f3;
  }
  &.disabled {
    box-shadow: none;
    pointer-events: none;
    opacity: 0.3;
  }
}
.action-btn-with-desc {
  flex-direction: column;
  align-items: center;
  width: 100px;
  text-align: center;
  .btn {
    border-radius: 5px;
    background-color: #eee;
    padding: 10px;
    cursor: pointer;
    height: 80px;
    width: 80px;
    margin: 0 10px;
    &.disabled {
      box-shadow: none;
      pointer-events: none;
      opacity: 0.3;
    }
    &:hover {
      box-shadow: 0 0 0 2px #2196f3;
    }
  }
}
.clear-btn {
  align-items: center;
  flex-wrap: nowrap;
  justify-content: center;
  cursor: pointer;
  border: 2px solid #999;
  border-radius: 4px;
  height: 30px;
  width: 30px;
  padding: 2px;
  color: #666;
  font-weight: bold;
}
.price-sub-zero {
  background-color: red;
  color: #fff;
}
.sep-bill-container {
  position: relative;
  z-index: 199;
  @media only screen and (min-width: 992px) {
    position: fixed;
    width: 80%;
    right: 0;
  }
}
.extension-alert {
  height: 50px;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  background-color: #ffd54f;
}
.no-printers-alert {
  height: 50px;
  flex-wrap: nowrap;
  align-items: center;
  padding: 5px;
  border-bottom: 1px solid #eee;
  background-color: #ffd54f;
}
.pup-card {
  width: 100%;
  margin: 5px;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    height: 50px;
    font-size: 16px;
    border-radius: 10px;
    border: 1px solid #ccc;
    padding: 5px;
    cursor: pointer;
    &.selected {
      box-shadow: 0 0 0 2px #2196f3;
    }
    &:hover {
      box-shadow: 0 0 0 2px #2196f3;
    }
  }
}
.pay-hint-search {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-around;
  button {
    margin-bottom: 10px;
  }
}
.pay-hint-search-inputs {
  width: 70%;
  flex-wrap: nowrap;
  input {
    margin: 0 5px 10px 5px;
  }
}
.pay-hint-div {
  height: calc(100% - 46px);
}
@media screen and(max-width: 767px) {
  .pay-hint-div {
    height: calc(100% - 92px);
  }
  .pay-hint-search-inputs {
    flex-direction: column;
    input {
      margin: 0 0 10px 0;
    }
  }
}
</style>
